import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import SignatureCanvas from 'react-signature-canvas';
import { contienePalabrasOfensivas } from '../utils/validaciones';
import Sidebar from '../components/Sidebar';
import Skeleton from '../components/Skeleton';
import Pagination from '../components/Pagination';
import PhotoCapture from '../components/PhotoCapture';
import { generateActaHTML } from '../templates/actaTemplates';
import { formatearRut } from '../utils/validaciones';
import { useAlert } from '../components/AlertContext';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast, confirm } = useAlert();
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get('tab') || 'activo';
  const currentClase = currentTab === 'entregas' ? 'Entregas' : currentTab === 'periferico' ? 'Periferico' : 'Activo';

  useEffect(() => {
    setFiltros(prev => ({ ...prev, categoria: '' }));
  }, [currentClase]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [dynamicCategorias, setDynamicCategorias] = useState([]);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');

  const fetchCategorias = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/categorias?clase=${currentClase}`, { credentials: 'include' });
      if (resp.ok) {
        const data = await resp.json();
        setDynamicCategorias(data);
        if (data.length > 0 && !formData.categoria) {
          setFormData(prev => ({ ...prev, categoria: data[0].nombre }));
        }
      }
    } catch (err) { console.error('Error al cargar categorías:', err); }
  };

  const handleAddCategory = async () => {
    if (!newCategoryName) return;
    try {
      const resp = await fetch(`${apiBase}/api/categorias`, { credentials: 'include', 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre: newCategoryName, clase: currentClase })
      });
      if (resp.ok) {
        setNewCategoryName('');
        fetchCategorias();
      }
    } catch (err) { console.error('Error al guardar categoría:', err); }
  };

  const currentCategorias = dynamicCategorias.map(c => ({ value: c.nombre, label: c.nombre }));



  const [searchTerm, setSearchTerm] = useState('');
  const [filtros, setFiltros] = useState({
    categoria: '',
    estado: ''
  });

  const [equipos, setEquipos] = useState([]);
  const [profanityList, setProfanityList] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedEquipo, setSelectedEquipo] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [mantenimientoHist, setMantenimientoHist] = useState([]);
  const [isHistorialLoading, setIsHistorialLoading] = useState(false);
  const [isMaintLoading, setIsMaintLoading] = useState(false);
  const [formMantenimiento, setFormMantenimiento] = useState({
    tipo: 'Preventivo',
    descripcion: '',
    tecnico: '',
    costo: ''
  });
  const [nuevoCustodio, setNuevoCustodio] = useState('');
  const [notaTransferencia, setNotaTransferencia] = useState('');
  const [isTransferring] = useState(false);
  const [referenciaActa, setReferenciaActa] = useState('Gestión Interna - UDT');
  const [autoActaType, setAutoActaType] = useState('recepcion');
  const [fechaDevolucion, setFechaDevolucion] = useState('');

  const [entregas, setEntregas] = useState([]);
  const [selectedEntrega, setSelectedEntrega] = useState(null);
  const [isEntregasLoading, setIsEntregasLoading] = useState(false);
  
  // Smart Match Modal
  const [showSmartAssignModal, setShowSmartAssignModal] = useState(false);
  const [assignSolicitud, setAssignSolicitud] = useState(null);
  const [assignData, setAssignData] = useState({ modo: 'inventario', equipoSeleccionado: '', textoManual: '' });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filtros, currentClase]);

  const [showPrintPrepModal, setShowPrintPrepModal] = useState(false);
  const [prepData, setPrepData] = useState({
    prepStep: 1,
    estadoGeneral: 'CONFORME',
    observaciones: '',
    signatureCustodio: null,
    signatureEncargado: null,
    actaType: 'recepcion',
    equipoToPrint: null,
    pendingAction: null,
    pendingPayload: null,
    mantenimientoTipo: 'Reparación Interna',
    mantenimientoNotas: '',
    mantenimientoEvidencia: null,
    trasladoEvidencia: null,
    prestamoRecipient: '',
    prestamoFecha: '',
    uemActivated: false
  });
  const sigPadCustodio = React.useRef(null);
  const sigPadEncargado = React.useRef(null);

  const [activeTab, setActiveTab] = useState('general');
  const [regTab, setRegTab] = useState('tecnica');
  const [apiError, setApiError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [isStatusQuickModalOpen, setIsStatusQuickModalOpen] = useState(false);
  const [statusTarget, setStatusTarget] = useState(null);
  const [fechaDevolucionStatus, setFechaDevolucionStatus] = useState('');
  const [maintTipo, setMaintTipo] = useState('Reparación Interna');
  const [maintNotas, setMaintNotas] = useState('');
  const [historyPage, setHistoryPage] = useState(1);
  const [selectedHistoryEvent, setSelectedHistoryEvent] = useState(null);
  const HISTORY_PER_PAGE = 5;

  const [formData, setFormData] = useState({
    codigo: '', modelo: '', categoria: '', estado: 'Sin uso', custodio: '', detalle: '',
    verificacion_operativa: false, 
    verificacion_fisica: false, 
    foto_verificacion_fisica: null
  });
  const [funcionariosList, setFuncionariosList] = useState([]);
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;



  const fetchEntregas = async () => {
    setIsEntregasLoading(true);
    try {
      const resp = await fetch(`${apiBase}/api/solicitudes`, { credentials: 'include', 
        headers: {  }
      });
      if (resp.ok) {
        const data = await resp.json();
        setEntregas(data.filter(s => s.estado === 'Aprobada por Jefatura' || s.estado === 'Pendiente de Firma'));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsEntregasLoading(false);
    }
  };

  const handleAbrirSmartAssign = () => {
    setAssignSolicitud(selectedEntrega);
    setAssignData({ modo: 'inventario', equipoSeleccionado: '', textoManual: '' });
    setSelectedEntrega(null);
    setShowSmartAssignModal(true);
  };

  const handleContinuarFirmaPendiente = async () => {
    let equipoStr = selectedEntrega.equipo_asignado;
    if (!equipoStr && selectedEntrega.datos_extra) {
      try {
        const extra = typeof selectedEntrega.datos_extra === 'string' ? JSON.parse(selectedEntrega.datos_extra) : selectedEntrega.datos_extra;
        equipoStr = extra.equipo_asignado;
      } catch (e) {}
    }

    console.log("[DEBUG] equipoStr extraído:", equipoStr, "datos_extra:", selectedEntrega.datos_extra);

    const selectedEquipoObj = equipos.find(eq => `${eq.modelo} (${eq.codigo})` === equipoStr || (equipoStr && equipoStr.includes(eq.codigo)));
    
    if (!selectedEquipoObj) {
      toast.warning(`No se encontró el equipo "${equipoStr || 'N/A'}" en el inventario. Quizás fue modificado o asignado manualmente.`);
      return;
    }

    const solicitanteRut = selectedEntrega.usuario_rut;
    const solicitante = funcionariosList.find(f => 
      f.rut === solicitanteRut || 
      (f.rut && solicitanteRut && f.rut.replace(/[^0-9kK]/g, '').toUpperCase() === solicitanteRut.replace(/[^0-9kK]/g, '').toUpperCase())
    );

    if (solicitante) {
      const usuario = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema';
      setPrepData({
        estadoGeneral: 'CONFORME',
        observaciones: `ENTREGA DE EQUIPO SEGÚN SOLICITUD N° ${selectedEntrega.id} (FIRMA PENDIENTE)`,
        signatureCustodio: null,
        signatureEncargado: null,
        actaType: 'recepcion',
        equipoToPrint: selectedEquipoObj,
        pendingAction: 'transfer_and_finalize_solicitud',
        pendingPayload: { 
          nuevoCustodio: solicitante.id, 
          nota: `Entregado por solicitud N° ${selectedEntrega.id} (Retiro Presencial)`, 
          usuario,
          solicitudId: selectedEntrega.id,
          equipoAsignadoStr: equipoStr
        },
        prepStep: 1
      });
      setSelectedEntrega(null);
      setShowPrintPrepModal(true);
    } else {
      toast.warning('No se encontró el funcionario en el directorio municipal.');
    }
  };

  const handleConfirmarSmartAssign = async (isFuncionarioPresente) => {
    let equipoAsignadoFinal = '';
    let selectedEquipoObj = null;

    if (assignData.modo === 'inventario') {
      if (!assignData.equipoSeleccionado) {
        toast.warning('Debe seleccionar un equipo del inventario o cambiar a ingreso manual.');
        return;
      }
      equipoAsignadoFinal = assignData.equipoSeleccionado;
      selectedEquipoObj = equipos.find(eq => `${eq.modelo} (${eq.codigo})` === assignData.equipoSeleccionado);
      
      if (isFuncionarioPresente && selectedEquipoObj) {
        const solicitanteRut = assignSolicitud.usuario_rut;
        const solicitante = funcionariosList.find(f => 
          f.rut === solicitanteRut || 
          (f.rut && solicitanteRut && f.rut.replace(/[^0-9kK]/g, '').toUpperCase() === solicitanteRut.replace(/[^0-9kK]/g, '').toUpperCase())
        );
        
        if (solicitante) {
          const usuario = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema';
          setPrepData({
            estadoGeneral: 'CONFORME',
            observaciones: `ENTREGA DE EQUIPO SEGÚN SOLICITUD N° ${assignSolicitud.id}`,
            signatureCustodio: null,
            signatureEncargado: null,
            actaType: 'recepcion',
            equipoToPrint: selectedEquipoObj,
            pendingAction: 'transfer_and_finalize_solicitud',
            pendingPayload: { 
              nuevoCustodio: solicitante.id, 
              nota: `Entregado por solicitud N° ${assignSolicitud.id}`, 
              usuario,
              solicitudId: assignSolicitud.id,
              equipoAsignadoStr: equipoAsignadoFinal
            },
            prepStep: 1
          });
          setShowSmartAssignModal(false);
          setShowPrintPrepModal(true);
          return;
        } else {
          toast.warning('No se encontró el funcionario en el directorio. Se completará sin acta automatizada.');
        }
      }
    } else {
      if (!assignData.textoManual) {
        toast.warning('Debe ingresar el detalle manualmente.');
        return;
      }
      equipoAsignadoFinal = assignData.textoManual;
    }

    try {
      const nuevoEstado = isFuncionarioPresente ? 'Finalizada' : 'Pendiente de Firma';
      const resp = await fetch(`${apiBase}/api/solicitudes/${assignSolicitud.id}`, { credentials: 'include', 
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nuevoEstado, equipo_asignado: equipoAsignadoFinal })
      });
      if (resp.ok) {
        setShowSmartAssignModal(false);
        setAssignSolicitud(null);
        fetchEntregas();
        if (isFuncionarioPresente) {
          toast.success('Entrega finalizada (Sin acta automática).');
        } else {
          toast.success('Solicitud en espera. Se ha notificado al funcionario por correo.');
        }
      } else {
        toast.error('Error al procesar la entrega.');
      }
    } catch (err) {
      toast.error('Error al procesar la entrega.');
      console.error(err);
    }
  };


  const fetchEquipos = async () => {
    setIsLoading(true);
    try {
      const qs = currentClase === 'Entregas' ? '' : `?clase=${currentClase}`;
      const resp = await fetch(`${apiBase}/api/equipos${qs}`, { credentials: 'include' });
      if (resp.ok) {
        const data = await resp.json();
        const mappedData = data.map(eq => ({ ...eq, custodio: eq.custodio_id }));
        setEquipos(mappedData);
      }
    } catch (err) {
      console.error('Error de red consultando Backend:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleExpandHistory = (id) => {
    // Deprecated for the new High-Fidelity view
  };

  const parseHistoryDetail = (detail = '') => {
    const data = {
      tipo: 'General',
      icon: 'fa-solid fa-clock-rotate-left',
      color: 'var(--p-blue)',
      fields: []
    };

    if (detail.includes('Transferencia:')) {
      data.tipo = 'Transferencia de Custodio';
      data.icon = 'fa-solid fa-right-left';
      data.color = 'var(--p-amber)';
      
      const parts = detail.split('—');
      const routePart = parts[0].replace('Transferencia:','').trim(); // de "X" a "Y"
      const motivoPart = parts[1]?.replace('Motivo:','').trim();

      const routeSplit = routePart.split(/de "(.*?)" a "(.*?)"/);
      if (routeSplit.length >= 3) {
        data.fields.push({ label: 'CUSTODIO ANTERIOR', value: routeSplit[1] || 'Sin asignar', icon: 'fa-solid fa-user-minus' });
        data.fields.push({ label: 'NUEVO CUSTODIO', value: routeSplit[2] || 'Sin asignar', icon: 'fa-solid fa-user-plus' });
      } else {
        data.fields.push({ label: 'DETALLE DE RUTA', value: routePart });
      }
      
      if (motivoPart) data.fields.push({ label: 'MOTIVO DEL CAMBIO', value: motivoPart, icon: 'fa-solid fa-comment-dots' });
    } 
    else if (detail.includes('Alta:')) {
      data.tipo = 'Registro Inicial';
      data.icon = 'fa-solid fa-star';
      data.color = 'var(--p-emerald)';
      data.fields.push({ label: 'ACCIÓN', value: 'Ingreso al Sistema de Inventario' });
      const obs = detail.split('- Detalle:')[1];
      if (obs) data.fields.push({ label: 'OBSERVACIONES INICIALES', value: obs.trim(), icon: 'fa-solid fa-file-contract' });
    }
    else if (detail.includes('Cambio de Estado:')) {
      data.tipo = 'Actualización de Estado';
      data.icon = 'fa-solid fa-arrows-rotate';
      const estado = detail.split('"')[1] || 'Nuevo Estado';
      data.fields.push({ label: 'NUEVO ESTADO', value: estado.toUpperCase(), icon: 'fa-solid fa-circle-check' });
    }
    else if (detail.includes('Ingreso a Mantenimiento:')) {
      data.tipo = 'Servicio Técnico';
      data.icon = 'fa-solid fa-toolbox';
      data.color = 'var(--p-rose)';
      const parts = detail.split(' - Obs: ');
      data.fields.push({ label: 'TIPO DE FALLA', value: parts[0].replace('Ingreso a Mantenimiento:','').trim() });
      if (parts[1]) data.fields.push({ label: 'OBSERVACIONES TÉCNICAS', value: parts[1].trim(), icon: 'fa-solid fa-notes-medical' });
    }
    else if (detail.includes('REPORTE DE INCIDENCIA:')) {
      data.tipo = 'Incidencia de Seguridad';
      data.icon = 'fa-solid fa-shield-virus';
      data.color = 'var(--p-rose)';
      data.fields.push({ label: 'TIPO DE INCIDENCIA', value: detail.replace('REPORTE DE INCIDENCIA:','').trim() });
    }
    else if (detail.includes('Préstamo de Activo a:')) {
      data.tipo = 'Asignación de Préstamo';
      data.icon = 'fa-solid fa-hand-holding-hand';
      data.color = 'var(--p-indigo)';
      const parts = detail.split('. Devolución programada:');
      data.fields.push({ label: 'BENEFICIARIO', value: parts[0].replace('Préstamo de Activo a:','').trim() });
      data.fields.push({ label: 'FECHA PROGRAMADA', value: parts[1]?.trim() || 'No definida' });
    }
    else {
      data.fields.push({ label: 'DESCRIPCIÓN DEL EVENTO', value: detail });
    }

    return data;
  };

  const fetchFuncionariosData = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/funcionarios`, { credentials: 'include' });
      if (resp.ok) setFuncionariosList(await resp.json());
    } catch (err) { console.error(err); }
  };

  const fetchProfanityList = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/config/profanity`, { credentials: 'include' });
      if (resp.ok) {
        const data = await resp.json();
        setProfanityList(data.words);
      }
    } catch (err) { console.error('Error fetching profanity list:', err); }
  };

  const fetchNetworkInfo = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/config/network-info`, { credentials: 'include' });
      if (resp.ok) {
        const data = await resp.json();
        console.log('Local IP for QR:', data.localIp);
      }
    } catch (err) { console.error('Error fetching network info:', err); }
  };



  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    // Si es Jefatura y NO tiene permiso para ver equipos, mandarlo a solicitudes (comportamiento legacy)
    if (currentUser.rol?.toLowerCase() === 'jefatura' && !(currentUser.permisos || []).includes('VER_EQUIPOS')) {
      navigate('/solicitudes');
      return;
    }

    if (currentClase === 'Entregas') {
      fetchEntregas();
      fetchEquipos(); // Fetch ALL equipments to allow signing
    } else {
      fetchEquipos();
      fetchCategorias();
    }
    fetchFuncionariosData();
    fetchProfanityList();
    fetchNetworkInfo();
  }, [currentClase, navigate, currentUser.rol]);

  useEffect(() => {
    if (!isModalOpen) {
      setFormData({
        codigo: '',
        modelo: '',
        categoria: currentCategorias.length > 0 ? currentCategorias[0].value : '',
        estado: 'En servicio',
        custodio: '',
        detalle: '',
        clase: currentClase,
        verificacion_operativa: false,
        verificacion_fisica: false,
        foto_verificacion_fisica: null
      });
    }
  }, [isModalOpen, currentClase, dynamicCategorias]);

  useEffect(() => {
    if (isScannerOpen) {
      const scanner = new window.Html5QrcodeScanner("reader", {
        fps: 10,
        qrbox: { width: 250, height: 250 }
      });

      scanner.render((decodedText) => {
        let code = decodedText;
        if (decodedText.includes('/equipo/')) {
          code = decodedText.split('/equipo/').pop();
        }

        const found = equipos.find(e => e.codigo === code);
        if (found) {
          scanner.clear();
          setIsScannerOpen(false);
          handleOpenDetails(found);
        } else {
          alert("Equipo no encontrado: " + code);
        }
      }, (error) => {
      });

      return () => scanner.clear();
    }
  }, [isScannerOpen, equipos]);

  const handleOpenModal = (equipo = null) => {
    setDetailModalOpen(false);
    setApiError(null);
    setRegTab('tecnica');
    setAutoActaType('recepcion');


    if (equipo) {
      setFormData({
        codigo: equipo.codigo,
        modelo: equipo.modelo,
        categoria: equipo.categoria || currentCategorias[0].value,
        estado: equipo.estado || 'Sin uso',
        custodio: equipo.custodio_id || '',
        detalle: equipo.detalle || '',
        clase: currentClase
      });
    } else {
      setFormData({
        codigo: 'AUTOGENERADO',
        modelo: '',
        categoria: currentCategorias[0].value,
        estado: 'Sin uso',
        custodio: '',
        detalle: '',
        clase: currentClase,
        verificacion_operativa: false,
        verificacion_fisica: false,
        foto_verificacion_fisica: null
      });
    }

    setIsModalOpen(true);


    fetchFuncionariosData();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setRegTab('tecnica');
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const handleNextStep = () => {
    setApiError(null);

    if (regTab === 'tecnica') {
      if (!formData.modelo || !formData.categoria) {
        setApiError('Debes completar los campos básicos (Modelo y Categoría).');
        return;
      }
      const offensiveWord = contienePalabrasOfensivas(`${formData.codigo} ${formData.modelo} ${formData.detalle}`, profanityList);
      if (offensiveWord) {
        setApiError(`Se ha detectado lenguaje inapropiado ("${offensiveWord}") en los detalles técnicos.`);
        return;
      }
      setRegTab('verificacion');
    } else if (regTab === 'verificacion') {
      if (!formData.verificacion_operativa || !formData.verificacion_fisica || !formData.foto_verificacion_fisica) {
        setApiError('¡Verificación Incompleta! Debes marcar los checks de seguridad y adjuntar la fotografía física obligatoria.');
        return;
      }
      setRegTab('asignacion');
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setApiError('');


    const offensiveWord = contienePalabrasOfensivas(`${formData.codigo} ${formData.modelo} ${formData.detalle}`, profanityList);
    if (offensiveWord) {
      setApiError(`Se ha detectado lenguaje inapropiado ("${offensiveWord}"). Por favor, revisa el contenido.`);
      return;
    }

    const usuario = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema';
    try {
      const resp = await fetch(`${apiBase}/api/equipos`, { credentials: 'include', 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, usuario, clase: currentClase })
      });
      if (!resp.ok) {
        const errData = await resp.json();
        throw new Error(errData.error || 'Error al crear equipo');
      }

      const newEntity = await resp.json();
      setIsModalOpen(false);


      await fetchFuncionariosData();

      if (formData.custodio) {
        const func = funcionariosList.find(f => f.id === formData.custodio);
        const tempEquipo = {
          ...formData,
          id: newEntity.id || 'N/A',
          custodio_nombre: func?.nombre,
          custodio_rut: func?.rut,
          custodio_cargo: func?.cargo
        };

        setTimeout(() => {
          setSelectedEquipo(tempEquipo);
          setPrepData({
            estadoGeneral: 'CONFORME',
            observaciones: 'INGRESO INICIAL A BODEGA Y REGISTRO EN INVENTARIO.',
            signatureCustodio: null,
            signatureEncargado: null,
            actaType: autoActaType,
            equipoToPrint: tempEquipo,
            pendingAction: 'create',
            pendingPayload: { ...formData, id: newEntity.id },
            prepStep: 1
          });
          setShowPrintPrepModal(true);
        }, 800);
      } else {
        const tempEquipo = {
          ...formData,
          id: newEntity.id || 'N/A',
          custodio_nombre: 'BODEGA MUNICIPAL',
          custodio_rut: 'Varios',
          custodio_cargo: 'Stock'
        };

        setTimeout(() => {
          setSelectedEquipo(tempEquipo);
          setPrepData({
            estadoGeneral: 'CONFORME',
            observaciones: 'ALTA DE BIEN MUNICIPAL - INGRESO A BODEGA.',
            signatureCustodio: null,
            signatureEncargado: null,
            actaType: 'ingreso_bodega',
            equipoToPrint: tempEquipo,
            pendingAction: 'create',
            pendingPayload: { ...formData, id: newEntity.id },
            prepStep: 1
          });
          setShowPrintPrepModal(true);
        }, 800);
      }

      fetchEquipos();
    } catch (err) {
      setApiError(err.message);
    }
  };

  const [actasArchivadas, setActasArchivadas] = useState([]);

  const handleOpenDetails = async (equipo) => {
    setIsModalOpen(false);
    setSelectedEquipo(equipo);
    setDetailModalOpen(true);
    setActiveTab('general');
    setNuevoCustodio(equipo.custodio_id || '');
    setNotaTransferencia('');
    setAutoActaType('traslado');
    setIsHistorialLoading(true);
    setHistorial([]);
    setActasArchivadas([]);
    setHistoryPage(1);

    try {
      const [histResp, actasResp, maintResp] = await Promise.all([
        fetch(`${apiBase}/api/equipos/${equipo.id}/historial`, { credentials: 'include' }),
        fetch(`${apiBase}/api/equipos/${equipo.id}/actas`, { credentials: 'include' }),
        fetch(`${apiBase}/api/equipos/${equipo.id}/mantenimiento`, { credentials: 'include' })
      ]);

      if (histResp.ok) setHistorial(await histResp.json());
      if (actasResp.ok) setActasArchivadas(await actasResp.json());
      if (maintResp.ok) setMantenimientoHist(await maintResp.json());
    } catch (err) {
      console.error('Error al obtener datos del equipo', err);
    } finally {
      setIsHistorialLoading(false);
    }
  };

  const fetchMantenimiento = async (equipoId) => {
    setIsMaintLoading(true);
    try {
      const resp = await fetch(`${apiBase}/api/equipos/${equipoId}/mantenimiento`, { credentials: 'include' });
      if (resp.ok) setMantenimientoHist(await resp.json());
    } catch (err) {
      console.error('Error al cargar mantenimiento:', err);
    } finally {
      setIsMaintLoading(false);
    }
  };

  const handleSaveMantenimiento = async (e) => {
    e.preventDefault();
    if (!selectedEquipo) return;
    try {
      const resp = await fetch(`${apiBase}/api/equipos/${selectedEquipo.id}/mantenimiento`, { credentials: 'include', 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formMantenimiento)
      });
      if (resp.ok) {
        setFormMantenimiento({ tipo: 'Preventivo', descripcion: '', tecnico: '', costo: '' });
        fetchMantenimiento(selectedEquipo.id);
      }
    } catch (err) {
      console.error('Error al guardar mantenimiento:', err);
    }
  };

  const handleChangeStatus = async (id, nuevoEstado) => {
    if (selectedEquipo && nuevoEstado === selectedEquipo.estado) return;

    if (nuevoEstado === 'En mantenimiento') {
      setPrepData({
        estadoGeneral: 'INCONFORME',
        observaciones: '',
        signatureCustodio: null,
        signatureEncargado: null,
        actaType: 'mantenimiento',
        equipoToPrint: selectedEquipo || statusTarget,
        pendingAction: 'status_mantenimiento',
        pendingPayload: { nuevoEstado: 'En mantenimiento' },
        mantenimientoTipo: 'Reparación Interna',
        mantenimientoNotas: '',
        mantenimientoEvidencia: null,
        prepStep: 1
      });
      setShowPrintPrepModal(true);
      return;
    }

    if (nuevoEstado === 'En préstamo') {
      setPrepData({
        estadoGeneral: 'CONFORME',
        observaciones: '',
        signatureCustodio: null,
        signatureEncargado: null,
        actaType: 'prestamo',
        equipoToPrint: selectedEquipo || statusTarget,
        pendingAction: 'status_prestamo',
        pendingPayload: { nuevoEstado: 'En préstamo' },
        mantenimientoTipo: '',
        mantenimientoNotas: '',
        mantenimientoEvidencia: null,
        prestamoRecipient: '',
        prestamoFecha: '',
        prepStep: 1
      });
      setShowPrintPrepModal(true);
      return;
    }

    if (nuevoEstado === 'Extraviado' || nuevoEstado === 'Sustraído') {
      setPrepData({
        estadoGeneral: 'INCONFORME',
        observaciones: `DEJANDO CONSTANCIA INTERNA DE: ${nuevoEstado.toUpperCase()}.`,
        signatureCustodio: null,
        signatureEncargado: null,
        actaType: 'incidencia',
        equipoToPrint: selectedEquipo || statusTarget,
        pendingAction: 'status_incidencia',
        pendingPayload: { nuevoEstado },
        mantenimientoTipo: nuevoEstado === 'Extraviado' ? 'PROTOCOLO EXTRAVÍO' : 'PROTOCOLO SUSTRACCIÓN',
        mantenimientoNotas: '',
        mantenimientoEvidencia: null,
        prepStep: 1
      });
      setShowPrintPrepModal(true);
      return;
    }

    if (nuevoEstado === 'Dado de baja') {
      setPrepData({
        estadoGeneral: 'INCONFORME',
        observaciones: 'RETIRO DEFINITIVO POR BAJA TÉCNICA.',
        signatureCustodio: null,
        signatureEncargado: null,
        actaType: 'mantenimiento',
        equipoToPrint: selectedEquipo || statusTarget,
        pendingAction: 'status_mantenimiento',
        pendingPayload: { nuevoEstado: 'Dado de baja' },
        mantenimientoTipo: 'Dado de baja',
        mantenimientoNotas: '',
        mantenimientoEvidencia: null,
        prepStep: 1
      });
      setShowPrintPrepModal(true);
      return;
    }

    setIsHistorialLoading(true);
    try {
      const resp = await fetch(`${apiBase}/api/equipos/${id}/estado`, { credentials: 'include', 
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nuevoEstado, usuario: JSON.parse(localStorage.getItem('user') || '{}').id || 'Sistema' })
      });
      if (resp.ok) {
        setSelectedEquipo({ ...selectedEquipo, estado: nuevoEstado });
        fetchEquipos();
        const histResp = await fetch(`${apiBase}/api/equipos/${id}/historial`, { credentials: 'include' });
        if (histResp.ok) {
          const logData = await histResp.json();
          setHistorial(logData);
        }
      } else {
        const errObj = await resp.json();
        toast.error('Error del servidor: ' + errObj.error);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsHistorialLoading(false);
    }
  };

  const handleTransferCustodio = async () => {
    if (nuevoCustodio === (selectedEquipo.custodio_id || '')) {
      return toast.warning('Selecciona un custodio diferente al actual.');
    }
    const selectedFunc = funcionariosList.find(f => f.id === nuevoCustodio);
    
    confirm(
      "Confirmar Transferencia",
      `¿Confirmar transferencia a: ${selectedFunc?.nombre || 'Sin asignar'}?`,
      () => {
        const usuario = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema';
        setPrepData({
          estadoGeneral: 'CONFORME',
          observaciones: notaTransferencia || (nuevoCustodio ? '' : 'DEVOLUCIÓN DE ACTIVO A BODEGA MUNICIPAL.'),
          signatureCustodio: null,
          signatureEncargado: null,
          actaType: nuevoCustodio ? autoActaType : 'devolucion',
          equipoToPrint: selectedEquipo,
          pendingAction: 'transfer',
          pendingPayload: { nuevoCustodio: nuevoCustodio || null, nota: notaTransferencia, usuario, evidencia: prepData.trasladoEvidencia },
          prepStep: 1
        });
        setShowPrintPrepModal(true);
      },
      { confirmText: 'Transferir', type: 'info' }
    );
  };

  const downloadQR = () => {
    const canvas = document.getElementById("qr-gen");
    if (!canvas) return;
    const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `ETIQUETA_QR_${selectedEquipo?.codigo || 'EQUIPO'}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handlePrintQR = () => {
    const canvas = document.getElementById("qr-gen");
    if (!canvas) return;
    const dataUrl = canvas.toDataURL("image/png");
    
    let custodio = 'Sin asignar';
    if (selectedEquipo?.custodio_id) {
       const fd = funcionariosList.find(f => f.id === selectedEquipo.custodio_id);
       if (fd) custodio = fd.nombre;
    }

    const codigoParts = selectedEquipo?.codigo ? selectedEquipo.codigo.split('-') : ['','',''];
    // Quita ceros a la izquierda si el formato de la imagen muestra "1" en lugar de "0001"
    if (codigoParts[2]) {
      codigoParts[2] = parseInt(codigoParts[2], 10).toString();
    }
    const displayCodigo = codigoParts.join(' - ');

    const windowContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Etiqueta Municipal - ${selectedEquipo?.codigo}</title>
          <style>
            body { margin: 0; font-family: 'Arial', sans-serif; display: flex; align-items: center; justify-content: center; height: 100vh; background: #e2e8f0; }
            .label-container { 
              background: white; 
              width: 70mm; height: 25mm; 
              padding: 0; 
              box-sizing: border-box;
              display: flex;
              align-items: center;
              overflow: hidden;
              border: 1px solid #eee;
            }
            .label-qr {
              flex: 0 0 23mm; /* Espacio más ajustado para ganar margen */
              height: 25mm;
              display: flex;
              align-items: center;
              justify-content: center;
              background: white;
            }
            img { width: 22mm; height: 22mm; display: block; image-rendering: pixelated; }
            
            .label-details {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding-left: 3px;
              overflow: hidden;
            }
            h2 { 
              margin: 0; 
              color: #000; 
              font-size: 18px; /* Tamaño optimizado para nombres largos */
              font-weight: 900; 
              letter-spacing: 0;
              white-space: nowrap;
            }
            
            .no-print { position: fixed; bottom: 20px; left: 0; width: 100%; text-align: center; }
            
            @media print {
              .no-print { display: none !important; }
              body { background: white; margin: 0; padding: 0; align-items: flex-start; justify-content: flex-start; }
              .label-container { border: none; }
            }
          </style>
        </head>
        <body>
          <div class="label-container">
            <div class="label-qr">
              <img src="${dataUrl}" />
            </div>
            <div class="label-details">
              <h2>${displayCodigo}</h2>
            </div>
          </div>
          <div class="no-print">
            <p style="font-size: 14px; margin-bottom: 10px; color: #334155; font-weight:bold;">PREVISTA DE ETIQUETA FORMATO OFICIAL</p>
            <button onclick="window.print()" style="padding: 10px 20px; background: #000; color: white; border: none; border-radius: 5px; cursor: pointer; font-size: 14px; font-weight:bold;">Imprimir Etiqueta</button>
            <button onclick="window.close()" style="padding: 10px 20px; background: #cbd5e1; color: #0f172a; border: none; border-radius: 5px; cursor: pointer; margin-left:10px; font-size: 14px; font-weight:bold;">Cerrar</button>
          </div>
        </body>
      </html>
    `;
    const printWindow = window.open('', '_blank', 'width=600,height=600');
    printWindow.document.open();
    printWindow.document.write(windowContent);
    printWindow.document.close();
  };

  const handleGenerateActa = async (type, overrideEquipo = null, extraData = null, existingCorrelativo = null) => {
    const currentEquipo = overrideEquipo || selectedEquipo;
    if (!currentEquipo) return;

    let correlativo = existingCorrelativo ? String(existingCorrelativo).padStart(4, '0') : "___";
    const fechaDevolucion = currentEquipo.fecha_devolucion;

    if (!existingCorrelativo) {
      try {
        const resp = await fetch(`${apiBase}/api/actas`, { credentials: 'include', 
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            equipo_id: currentEquipo.id,
            tipo: type,
            referencia: referenciaActa,
            data_json: extraData ? JSON.stringify(extraData) : null,
            fecha_devolucion: type === 'prestamo' ? fechaDevolucion : null,
            usuario: JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema',
            observaciones: extraData?.observaciones || '',
            estadoGeneral: extraData?.estadoGeneral || '',
            custodio_id: extraData?.selectedFuncionarioId || null
          })
        });

        if (resp.ok) {
          const data = await resp.json();
          correlativo = String(data.correlativo).padStart(4, '0');
        } else {
          const errData = await resp.json();
          alert('Aviso: Correlativo de Acta generado pero el archivo digital puede haber fallado: ' + errData.error);
        }
      } catch (error) {
        alert('Error de conexión al intentar archivar el documento.');
      }
    }

    const funcionarioData = funcionariosList.find(f =>
      f.id === (currentEquipo.custodio_id || currentEquipo.custodio) ||
      (f.nombre || "").trim().toLowerCase() === (currentEquipo.custodio_nombre || "").trim().toLowerCase()
    );

    const docNombre = (funcionarioData && funcionarioData.nombre) ? funcionarioData.nombre : (currentEquipo.custodio_nombre || currentEquipo.custodio || '__________________________');
    const docRut = (funcionarioData && funcionarioData.rut) ? funcionarioData.rut : (currentEquipo.custodio_rut || '__________________________');
    const docCargo = (funcionarioData && funcionarioData.cargo) ? funcionarioData.cargo : (currentEquipo.custodio_cargo || '__________________________');

    const dateStr = new Date().toLocaleDateString('es-CL', { day: '2-digit', month: 'long', year: 'numeric' });
    const logoUrl = '/logo_pitrufquen.png';

    let mainTitle = "";
    let objectiveText = "";
    let declarationExtra = "";
    let typeCode = "";

    if (type === 'recepcion') {
      mainTitle = "Acta de Recepción Conforme de Activo";
      typeCode = "AC - RecepciónConformeActivo";
      objectiveText = "certificar la recepción física y la conformidad de los activos detallados, los cuales han sido inspeccionados por la parte que recibe y se encuentran en buen estado, completos y cumplen con las especificaciones técnicas o requisitos de la Orden de Compra/Contrato de referencia.";
    } else if (type === 'traslado') {
      mainTitle = "Acta de Traslado de Activo";
      typeCode = "AC - TrasladoActivo";
      objectiveText = "documentar el movimiento físico y cambio de ubicación de los activos detallados entre distintas dependencias municipales, asegurando su trazabilidad y correcto estado.";
    } else if (type === 'prestamo') {
      mainTitle = "Acta de Préstamo de Activo";
      typeCode = "AC - PréstamoActivo";
      objectiveText = "certificar la recepción física de los activos en préstamo, estos deberán ser inspeccionados por la parte que recibe, cerciorando que se encuentran en buen estado, completos y cumplen con las especificaciones técnicas o requisitos solicitados.";
      declarationExtra = " de Préstamo de Activo";
    } else if (type === 'mantenimiento') {
      mainTitle = "Acta de Entrega a Mantenimiento Técnico";
      typeCode = "AC - MantenimientoTécnico";
      objectiveText = "documentar la salida física del activo desde su ubicación habitual hacia el servicio técnico o área de mantenimiento, con el fin de realizar reparaciones, revisiones preventivas o correctivas, asegurando el control del bien durante su permanencia fuera de uso operativo.";
    } else if (type === 'devolucion') {
      mainTitle = "Acta de Reintegro de Activo a Bodega";
      typeCode = "AC - ReintegroBodega";
      objectiveText = "formalizar la devolución física del activo a la bodega municipal por parte del funcionario custodio, certificando el término de su responsabilidad directa sobre el bien y su reincorporación al stock general.";
    } else if (type === 'ingreso_bodega') {
      mainTitle = "Acta de Ingreso y Alta en Inventario Municipal";
      typeCode = "AC - IngresoInventario";
      objectiveText = "certificar la incorporación física de un nuevo activo al patrimonio municipal y su ingreso inicial a la bodega de la Unidad de Desarrollo Tecnológico, validando sus características técnicas y estado de recepción.";
    } else if (type === 'incidencia') {
      mainTitle = "Informe Técnico de Incidencia / Protocolo de Seguridad";
      typeCode = "IT - IncidenciaSeguridad";
      objectiveText = "documentar formalmente la pérdida, extravío o sustracción de un activo municipal, dejando constancia del relato de los hechos y la activación de los protocolos de seguridad institucional correspondientes.";
    }

    const isInforme = type === 'mantenimiento' || type === 'incidencia';

    const encargadoNombre = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Encargado/a de Inventario';

    const windowContent = generateActaHTML({
      type,
      currentEquipo,
      correlativo,
      docNombre,
      docRut,
      docCargo,
      dateStr,
      extraData,
      logoUrl,
      referenciaActa,
      funcionarioData,
      declarationExtra,
      mainTitle,
      typeCode,
      objectiveText,
      isInforme,
      encargadoNombre
    });
    const printWindow = window.open('', '_blank', 'width=1000,height=900');
    printWindow.document.open();
    printWindow.document.write(windowContent);
    printWindow.document.close();
  };

  const filteredEquipos = equipos.filter(eq => {
    const term = searchTerm.toLowerCase();
    const matchesSearch = (
      (eq.codigo && eq.codigo.toLowerCase().includes(term)) ||
      (eq.modelo && eq.modelo.toLowerCase().includes(term)) ||
      (eq.categoria && eq.categoria.toLowerCase().includes(term)) ||
      (eq.estado && eq.estado.toLowerCase().includes(term)) ||
      (eq.detalle && eq.detalle.toLowerCase().includes(term))
    );
    const matchesCat = !filtros.categoria || eq.categoria === filtros.categoria;
    const matchesEstado = !filtros.estado || eq.estado === filtros.estado;

    return matchesSearch && matchesCat && matchesEstado;
  });

  const totalPages = Math.ceil(filteredEquipos.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredEquipos.slice(indexOfFirstItem, indexOfLastItem);

  const getEstadoColor = (estado) => {
    const map = { 'En servicio': '#10b981', 'Sin uso': '#94a3b8', 'En mantenimiento': '#f59e0b', 'En préstamo': '#6366f1', 'Extraviado': '#f43f5e', 'Sustraído': '#f43f5e', 'Dado de baja': '#64748b' };
    return map[estado] || '#94a3b8';
  };

  const getCatColor = (cat) => {
    if (!cat) return '#94a3b8';
    const hash = cat.split('').reduce((a, c) => c.charCodeAt(0) + ((a << 5) - a), 0);
    const colors = ['#6366f1','#0ea5e9','#10b981','#f59e0b','#ec4899','#8b5cf6','#14b8a6','#f97316'];
    return colors[Math.abs(hash) % colors.length];
  };

  const estadoChips = [
    { label: 'En servicio', icon: 'fa-circle-check', color: '#10b981' },
    { label: 'Sin uso', icon: 'fa-box-archive', color: '#94a3b8' },
    { label: 'En mantenimiento', icon: 'fa-wrench', color: '#f59e0b' },
    { label: 'En préstamo', icon: 'fa-handshake', color: '#6366f1' },
    { label: 'Extraviado', icon: 'fa-triangle-exclamation', color: '#f43f5e' },
    { label: 'Dado de baja', icon: 'fa-trash-can', color: '#64748b' },
  ];

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <main className="main-content">
        <div className="content-header">
          <div className="header-title">
            <h1 className="heading-premium">Inventario Municipal</h1>
          </div>
          <div className="header-actions" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <Link to="/perfil" className="user-profile">
              <span>{JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Mi Perfil'}</span>
              <div className="avatar">
                {JSON.parse(localStorage.getItem('user') || '{}').nombre?.charAt(0).toUpperCase() || 'P'}
              </div>
            </Link>
          </div>
        </div>

        {currentClase !== 'Entregas' && (
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
            {estadoChips.map(chip => {
              const count = equipos.filter(e => e.estado === chip.label).length;
              const isActive = filtros.estado === chip.label;
              return (
                <button key={chip.label} onClick={() => setFiltros({ ...filtros, estado: isActive ? '' : chip.label })}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 14px', borderRadius: '12px',
                    border: isActive ? `2px solid ${chip.color}` : '1px solid var(--glass-border)',
                    background: isActive ? `${chip.color}15` : 'var(--card-bg)', cursor: 'pointer',
                    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    transform: isActive ? 'scale(1.05)' : 'scale(1)',
                    boxShadow: isActive ? `0 4px 15px ${chip.color}25` : 'none'
                  }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '8px', background: `${chip.color}20`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: chip.color, fontSize: '12px' }}>
                    <i className={`fa-solid ${chip.icon}`}></i>
                  </div>
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '16px', fontWeight: '800', color: chip.color, lineHeight: 1 }}>{count}</div>
                    <div style={{ fontSize: '9px', fontWeight: '700', color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.3px' }}>{chip.label}</div>
                  </div>
                </button>
              );
            })}
          </div>
        )}

        <section className="datatable-section">
          <div className="datatable-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '25px' }}>
            {currentClase === 'Entregas' ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                 <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, var(--p-emerald), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px' }}>
                   <i className="fa-solid fa-box-open"></i>
                 </div>
                 <div>
                   <h2 style={{ margin: 0, fontSize: '18px', color: 'var(--p-navy)', letterSpacing: '0.3px' }}>Entregas Pendientes</h2>
                   <p style={{ margin: 0, fontSize: '11px', color: 'var(--p-slate)' }}>Solicitudes autorizadas por jefatura</p>
                 </div>
                 {entregas.length > 0 && <span style={{ fontSize: '11px', fontWeight: '700', color: 'var(--p-emerald)', background: 'rgba(16, 185, 129, 0.1)', padding: '4px 12px', borderRadius: '12px', border: '1px solid rgba(16, 185, 129, 0.2)' }}>{entregas.length}</span>}
                 <button className={`action-button-glass ${isEntregasLoading ? 'loading-spin' : ''}`} onClick={fetchEntregas} disabled={isEntregasLoading}>
                   <i className={`fa-solid fa-arrows-rotate ${isEntregasLoading ? 'fa-spin' : ''}`}></i>
                 </button>
              </div>
            ) : (
              <div className="header-actions" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                <div className="search-bar" style={{ margin: 0, position: 'relative' }}>
                  <i className="fa-solid fa-magnifying-glass" style={{ position: 'absolute', marginLeft: '15px', marginTop: '16px', color: '#94a3b8' }}></i>
                  <input
                    type="text"
                    placeholder="Buscar equipo..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ paddingLeft: '40px', width: '250px' }}
                  />
                </div>

                <select
                  className="select-premium"
                  style={{ width: '180px' }}
                  value={filtros.categoria}
                  onChange={(e) => setFiltros({ ...filtros, categoria: e.target.value })}
                >
                  <option value="">Todas las Categorías</option>
                  {currentCategorias.map(cat => (
                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                  ))}
                </select>

                {(currentUser.rol === 'superadmin' || (currentUser.permisos || []).includes('MODULO_ADMIN')) && (
                    <button
                      className="btn-secondary"
                      title="Gestionar Categorías"
                      onClick={() => setIsCategoryModalOpen(true)}
                      style={{ height: '45px', width: '45px', padding: 0, justifyContent: 'center' }}
                    >
                      <i className="fa-solid fa-tags"></i>
                    </button>
                  )}

                <button className="btn-primary" onClick={handleOpenModal} style={{ height: '45px', margin: 0 }}>
                  <i className="fa-solid fa-plus"></i> Nuevo {currentClase}
                </button>
              </div>
            )}
          </div>

          <div className="table-responsive">
            <table className="data-table">
              {currentClase === 'Entregas' ? (
                <>
                  <thead>
                    <tr>
                      <th><i className="fa-regular fa-calendar" style={{ marginRight: '6px', opacity: 0.6 }}></i>Fecha</th>
                      <th><i className="fa-solid fa-user" style={{ marginRight: '6px', opacity: 0.6 }}></i>Funcionario</th>
                      <th><i className="fa-solid fa-building" style={{ marginRight: '6px', opacity: 0.6 }}></i>Departamento</th>
                      <th><i className="fa-solid fa-laptop" style={{ marginRight: '6px', opacity: 0.6 }}></i>Equipo a Entregar</th>
                      <th style={{ textAlign: 'right' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isEntregasLoading ? (
                      <tr><td colSpan="5"><Skeleton height="30px" /></td></tr>
                    ) : entregas.length === 0 ? (
                      <tr><td colSpan="5" style={{ textAlign: 'center', padding: '60px', color: 'var(--p-slate)' }}>
                        <i className="fa-solid fa-inbox" style={{ fontSize: '30px', display: 'block', marginBottom: '12px', opacity: 0.4 }}></i>
                        No hay entregas pendientes autorizadas por Jefatura.
                      </td></tr>
                    ) : entregas.map(s => (
                      <tr key={s.id}>
                        <td><span style={{ fontSize: '13px', fontWeight: '600' }}>{new Date(s.creado_en).toLocaleDateString()}</span></td>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>{(s.usuario_nombre || '?').charAt(0)}</div>
                            <div>
                              <strong style={{ fontSize: '13px' }}>{s.usuario_nombre}</strong>
                              <div style={{ fontSize: '11px', color: 'var(--p-slate)', fontFamily: 'var(--font-mono)' }}>{s.usuario_rut}</div>
                            </div>
                          </div>
                        </td>
                        <td>{s.departamento}</td>
                        <td>
                          <span style={{ color: 'var(--p-blue)', fontWeight: '600', display: 'block' }}>{s.equipo_solicitado}</span>
                          {s.estado === 'Pendiente de Firma' && (
                            <div style={{ marginTop: '5px', fontSize: '11px', color: '#3b82f6', background: 'rgba(59, 130, 246, 0.1)', padding: '4px 8px', borderRadius: '6px', display: 'inline-block', border: '1px solid rgba(59, 130, 246, 0.2)' }}>
                              <i className="fa-solid fa-file-signature" style={{ marginRight: '4px' }}></i>
                              Firma Pendiente (Notificado)
                            </div>
                          )}
                          {(() => {
                            try {
                              const d = typeof s.datos_extra === 'string' ? JSON.parse(s.datos_extra) : (s.datos_extra || {});
                              if (d.destinatario_prestamo) {
                                return (
                                  <div style={{ marginTop: '5px', fontSize: '11px', color: 'var(--p-amber)', background: 'rgba(245, 158, 11, 0.1)', padding: '4px 8px', borderRadius: '6px', display: 'inline-block', border: '1px solid rgba(245, 158, 11, 0.2)' }}>
                                    <i className="fa-solid fa-user-tag" style={{ marginRight: '4px' }}></i>
                                    Beneficiario: <strong>{d.destinatario_prestamo}</strong>
                                  </div>
                                );
                              }
                            } catch(e) {}
                            return null;
                          })()}
                        </td>
                        <td style={{ textAlign: 'right' }}>
                          <button className="btn-secondary" style={{ padding: '7px 16px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px' }} onClick={() => setSelectedEntrega(s)}>
                             Gestionar <i className="fa-solid fa-arrow-right" style={{ fontSize: '10px' }}></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </>
              ) : (
                <>
                  <thead>
                    <tr>
                      <th style={{ width: '4px', padding: 0 }}></th>
                      <th>Código</th>
                      <th>Modelo</th>
                      <th>Categoría</th>
                      <th>Estado</th>
                      <th style={{ textAlign: 'right' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      [...Array(itemsPerPage)].map((_, i) => (
                        <tr key={i} className="skeleton-row-tr">
                          <td style={{ padding: 0, width: '4px' }}></td>
                          <td><Skeleton width="100px" /></td>
                          <td><Skeleton width="180px" /></td>
                          <td><Skeleton width="120px" /></td>
                          <td><Skeleton width="100px" /></td>
                          <td style={{ textAlign: 'right' }}><Skeleton width="80px" /></td>
                        </tr>
                      ))
                    ) : currentItems.length > 0 ? (
                      currentItems.map(eq => (
                        <tr key={eq.id} style={{ cursor: 'pointer' }} onClick={() => handleOpenDetails(eq)}>
                          <td style={{ padding: 0, width: '4px', background: getEstadoColor(eq.estado), borderBottom: '1px solid var(--glass-border)' }}></td>
                          <td>
                            <span style={{ fontFamily: "'Roboto Mono', monospace", fontSize: '12px', fontWeight: '700', background: 'var(--bg-subtle)', padding: '4px 10px', borderRadius: '6px', border: '1px solid var(--glass-border)', letterSpacing: '0.5px' }}>
                              {eq.codigo}
                            </span>
                          </td>
                          <td>
                            <div>
                              <strong style={{ fontSize: '14px' }}>{eq.modelo}</strong>
                              <div style={{ fontSize: '11px', color: eq.custodio_nombre && eq.custodio_nombre !== 'BODEGA MUNICIPAL' ? 'var(--p-blue)' : 'var(--p-slate)', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <i className={`fa-solid ${eq.custodio_nombre && eq.custodio_nombre !== 'BODEGA MUNICIPAL' ? 'fa-user' : 'fa-warehouse'}`} style={{ fontSize: '9px' }}></i>
                                {eq.custodio_nombre || 'En bodega'}
                              </div>
                            </div>
                          </td>
                          <td>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '5px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', background: `${getCatColor(eq.categoria)}12`, color: getCatColor(eq.categoria), border: `1px solid ${getCatColor(eq.categoria)}25` }}>
                              {eq.categoria || 'N/A'}
                            </span>
                          </td>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {(eq.estado === 'En mantenimiento' || eq.estado === 'Extraviado') && (
                                <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: getEstadoColor(eq.estado), boxShadow: `0 0 0 3px ${getEstadoColor(eq.estado)}30`, animation: 'pulseGlow 2s ease-in-out infinite', flexShrink: 0 }}></span>
                              )}
                              <span style={{ padding: '5px 12px', borderRadius: '30px', fontSize: '11px', fontWeight: '700', background: `${getEstadoColor(eq.estado)}15`, color: getEstadoColor(eq.estado), border: `1px solid ${getEstadoColor(eq.estado)}30` }}>
                                {eq.estado}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: 'right' }} onClick={e => e.stopPropagation()}>
                            <div className="table-actions" style={{ justifyContent: 'flex-end' }}>
                              <button className="action-button-glass" title="Cambiar Estado" onClick={() => { setStatusTarget(eq); setIsStatusQuickModalOpen(true); }} style={{ color: 'var(--p-blue)' }}>
                                <i className="fa-solid fa-arrows-rotate"></i>
                              </button>
                              <button className="action-button-glass" onClick={() => handleOpenDetails(eq)} title="Detalles">
                                <i className="fa-solid fa-list-check"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="6" className="no-results" style={{ textAlign: 'center', padding: '60px' }}>El inventario está vacío.</td></tr>
                    )}
                  </tbody>
                </>
              )}
            </table>
          </div>

          {((currentClase === 'Entregas' ? entregas.length : filteredEquipos.length) > 0) && (
            <Pagination 
              currentPage={currentPage}
              totalPages={currentClase === 'Entregas' ? Math.ceil(entregas.length / itemsPerPage) : totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </section>
      </main>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal">
            <div className="modal-header" style={{ marginBottom: '25px' }}>
              <h3 style={{ color: 'var(--p-navy)', margin: 0 }}>Registrar Nuevo {currentClase}</h3>
            </div>

            <div className="modal-tabs">
              <button type="button" className={`tab-btn modal-tab ${regTab === 'tecnica' ? 'active' : ''} ${(formData.modelo) ? 'completed' : ''} ${regTab === 'tecnica' ? 'active' : ''}`} onClick={() => setRegTab('tecnica')}>
                <div className="tab-number">{formData.modelo && regTab !== 'tecnica' ? <i className="fa-solid fa-check"></i> : '1'}</div>
                Datos Técnicos
              </button>
              <button 
                type="button" 
                className={`tab-btn modal-tab ${regTab === 'verificacion' ? 'active' : ''} ${(formData.verificacion_operativa && formData.verificacion_fisica && formData.foto_verificacion_fisica) ? 'completed' : ''}`}
                onClick={() => {
                  if (formData.modelo) setRegTab('verificacion');
                  else alert('Debes completar el Modelo antes de continuar.');
                }}
                disabled={!formData.modelo}
                style={{ opacity: (!formData.modelo) ? 0.35 : 1, cursor: (!formData.modelo) ? 'not-allowed' : 'pointer' }}
              >
                <div className="tab-number">{(formData.verificacion_operativa && formData.verificacion_fisica && formData.foto_verificacion_fisica && regTab !== 'verificacion') ? <i className="fa-solid fa-check"></i> : '2'}</div>
                Verificación
              </button>
              <button
                type="button"
                className={`tab-btn modal-tab ${regTab === 'asignacion' ? 'active' : ''}`}
                onClick={() => {
                  if (formData.verificacion_operativa && formData.verificacion_fisica && formData.foto_verificacion_fisica) setRegTab('asignacion');
                  else alert('Debes completar las verificaciones antes de continuar.');
                }}
                disabled={!formData.verificacion_operativa || !formData.verificacion_fisica || !formData.foto_verificacion_fisica}
                style={{ opacity: (!formData.verificacion_operativa || !formData.verificacion_fisica || !formData.foto_verificacion_fisica) ? 0.35 : 1, cursor: (!formData.verificacion_operativa || !formData.verificacion_fisica || !formData.foto_verificacion_fisica) ? 'not-allowed' : 'pointer' }}
              >
                <div className="tab-number">3</div>
                Asignación
              </button>
            </div>

            <form onSubmit={handleSave} className="crud-form">
              <div className="modal-scroll-area">
                {regTab === 'tecnica' && (
                  <div className="tab-pane">
                    {apiError && <div style={{ color: 'var(--p-rose)', textAlign: 'center', marginBottom: '15px', background: 'var(--sidebar-accent)', padding: '12px', borderRadius: '10px', border: '1px solid var(--glass-border)', fontSize: '13px' }}>
                      <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '8px' }}></i> {apiError}
                    </div>}
                    <div className="form-row">
                      <div className="premium-field">
                        <label><i className="fa-solid fa-barcode" style={{ color: 'var(--p-blue)' }}></i> Identificador Municipal</label>
                        <div style={{ padding: '14px 16px', borderRadius: '10px', background: 'var(--sidebar-accent)', border: '1px dashed var(--glass-border)', color: 'var(--p-blue)', fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <i className="fa-solid fa-lock" style={{ fontSize: '10px', color: 'var(--p-slate)' }}></i>
                          <span>Autogenerado</span>
                          <span style={{ color: 'var(--p-slate)', fontWeight: '400', fontSize: '11px', marginLeft: 'auto' }}>Ej: ACT-PC-0001</span>
                        </div>
                      </div>
                      <div className="premium-field">
                        <label><i className="fa-solid fa-laptop" style={{ color: 'var(--p-indigo)' }}></i> Modelo <span style={{ color: 'var(--p-rose)', fontSize: '14px' }}>*</span></label>
                        <input required name="modelo" value={formData.modelo} onChange={handleFormChange} placeholder="Ej: Dell Optiplex 7090, HP EliteBook 840..." />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="premium-field">
                        <label><i className="fa-solid fa-tag" style={{ color: 'var(--p-emerald)' }}></i> Categoría</label>
                        <select className="select-premium" name="categoria" value={formData.categoria} onChange={handleFormChange} style={{ width: '100%', height: '50px' }}>
                          {currentCategorias.map(cat => (
                            <option key={cat.value} value={cat.value}>{cat.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="premium-field">
                        <label><i className="fa-solid fa-circle-check" style={{ color: 'var(--p-emerald)' }}></i> Estado Inicial</label>
                        <div style={{ padding: '14px 16px', borderRadius: '10px', background: 'var(--sidebar-accent)', border: '1px dashed var(--glass-border)', color: 'var(--p-emerald)', fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <i className="fa-solid fa-lock" style={{ fontSize: '10px', color: 'var(--p-slate)' }}></i>
                          <span>Sin uso</span>
                          <span style={{ color: 'var(--p-slate)', fontWeight: '400', fontSize: '11px', marginLeft: 'auto' }}>automático</span>
                        </div>
                      </div>
                    </div>
                    <div className="premium-field" style={{ marginTop: '5px' }}>
                      <label><i className="fa-solid fa-clipboard-list" style={{ color: 'var(--p-amber)' }}></i> Especificaciones y Detalles</label>
                      <textarea rows="4" name="detalle" value={formData.detalle} onChange={handleFormChange} placeholder="Detalla RAM, Procesador, Marca, Número de serie u otras observaciones..." style={{ minHeight: '120px' }} />
                    </div>

                    <div className="modal-footer-actions">
                      <button type="button" className="btn-secondary" onClick={() => { setIsModalOpen(false); setApiError(null); }}>Cancelar</button>
                      <button
                        type="button"
                        className="btn-primary"
                        onClick={handleNextStep}
                        disabled={!formData.modelo}
                        style={{ opacity: (!formData.modelo) ? 0.4 : 1 }}
                      >
                        Continuar <i className="fa-solid fa-arrow-right" style={{ marginLeft: '6px' }}></i>
                      </button>
                    </div>
                  </div>
                )}

                {regTab === 'verificacion' && (
                  <div className="tab-pane">
                    {apiError && <div style={{ color: 'var(--p-rose)', textAlign: 'center', marginBottom: '15px', background: 'var(--sidebar-accent)', padding: '12px', borderRadius: '10px', border: '1px solid var(--glass-border)', fontSize: '13px' }}>
                      <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '8px' }}></i> {apiError}
                    </div>}

                    <div style={{
                      padding: '25px',
                      background: 'var(--card-bg)',
                      borderRadius: '16px',
                      border: '1px solid var(--glass-border)',
                      marginBottom: '20px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px', paddingBottom: '15px', borderBottom: '1px solid var(--glass-border)' }}>
                        <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '18px', flexShrink: 0 }}>
                          <i className="fa-solid fa-shield-halved"></i>
                        </div>
                        <div>
                          <h4 style={{ color: 'var(--p-navy)', margin: 0, fontSize: '15px' }}>Protocolo de Verificación</h4>
                          <p style={{ color: 'var(--p-slate)', fontSize: '12px', margin: 0 }}>Valida el estado técnico y físico antes de la asignación.</p>
                        </div>
                      </div>
                      
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '25px' }}>
                        <label style={{ 
                          display: 'flex', alignItems: 'center', gap: '14px', 
                          color: 'var(--p-navy)', fontSize: '14px', cursor: 'pointer',
                          padding: '16px', borderRadius: '12px',
                          background: formData.verificacion_operativa ? 'rgba(16, 185, 129, 0.08)' : 'var(--bg-subtle)',
                          border: '1.5px solid',
                          borderColor: formData.verificacion_operativa ? 'var(--p-emerald)' : 'var(--glass-border)',
                          transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                        }}>
                          <div style={{
                            width: '24px', height: '24px', borderRadius: '8px', flexShrink: 0,
                            background: formData.verificacion_operativa ? 'var(--p-emerald)' : 'transparent',
                            border: formData.verificacion_operativa ? 'none' : '2px solid var(--glass-border)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            transition: 'all 0.3s', color: 'white', fontSize: '12px'
                          }}>
                            {formData.verificacion_operativa && <i className="fa-solid fa-check"></i>}
                          </div>
                          <input type="checkbox" name="verificacion_operativa" checked={formData.verificacion_operativa} onChange={handleFormChange} style={{ display: 'none' }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: '700', fontSize: '13px' }}>Verificación Operativa</div>
                            <div style={{ fontSize: '11px', color: 'var(--p-slate)', marginTop: '2px' }}>El equipo enciende y funciona correctamente</div>
                          </div>
                          {formData.verificacion_operativa && <i className="fa-solid fa-circle-check" style={{ color: 'var(--p-emerald)', fontSize: '16px', flexShrink: 0 }}></i>}
                        </label>

                        <label style={{ 
                          display: 'flex', alignItems: 'center', gap: '14px', 
                          color: 'var(--p-navy)', fontSize: '14px', cursor: 'pointer',
                          padding: '16px', borderRadius: '12px',
                          background: formData.verificacion_fisica ? 'rgba(16, 185, 129, 0.08)' : 'var(--bg-subtle)',
                          border: '1.5px solid',
                          borderColor: formData.verificacion_fisica ? 'var(--p-emerald)' : 'var(--glass-border)',
                          transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                        }}>
                          <div style={{
                            width: '24px', height: '24px', borderRadius: '8px', flexShrink: 0,
                            background: formData.verificacion_fisica ? 'var(--p-emerald)' : 'transparent',
                            border: formData.verificacion_fisica ? 'none' : '2px solid var(--glass-border)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            transition: 'all 0.3s', color: 'white', fontSize: '12px'
                          }}>
                            {formData.verificacion_fisica && <i className="fa-solid fa-check"></i>}
                          </div>
                          <input type="checkbox" name="verificacion_fisica" checked={formData.verificacion_fisica} onChange={handleFormChange} style={{ display: 'none' }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: '700', fontSize: '13px' }}>Verificación Física</div>
                            <div style={{ fontSize: '11px', color: 'var(--p-slate)', marginTop: '2px' }}>Sin daños visibles, etiquetas y accesorios completos</div>
                          </div>
                          {formData.verificacion_fisica && <i className="fa-solid fa-circle-check" style={{ color: 'var(--p-emerald)', fontSize: '16px', flexShrink: 0 }}></i>}
                        </label>
                      </div>

                      <div>
                        <label style={{ fontSize: '13px', color: 'var(--p-slate)', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>
                          <i className="fa-solid fa-camera" style={{ color: 'var(--p-blue)' }}></i> Evidencia Fotográfica
                        </label>
                        <PhotoCapture
                          id="reg-photo-step"
                          preview={formData.foto_verificacion_fisica}
                          onCapture={(result) => setFormData(prev => ({ ...prev, foto_verificacion_fisica: result }))}
                          onClear={() => setFormData(prev => ({ ...prev, foto_verificacion_fisica: null }))}
                        />
                      </div>
                    </div>

                    <div className="modal-footer-actions">
                      <button type="button" className="btn-secondary" onClick={() => setRegTab('tecnica')}>
                        <i className="fa-solid fa-arrow-left" style={{ marginRight: '6px' }}></i> Volver
                      </button>
                      <button
                        type="button"
                        className="btn-primary"
                        onClick={handleNextStep}
                        disabled={!formData.verificacion_operativa || !formData.verificacion_fisica || !formData.foto_verificacion_fisica}
                        style={{ opacity: (!formData.verificacion_operativa || !formData.verificacion_fisica || !formData.foto_verificacion_fisica) ? 0.4 : 1 }}
                      >
                        Continuar <i className="fa-solid fa-arrow-right" style={{ marginLeft: '6px' }}></i>
                      </button>
                    </div>
                  </div>
                )}

                {regTab === 'asignacion' && (
                  <div className="tab-pane">
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', padding: '18px', background: 'var(--sidebar-accent)', borderRadius: '12px', border: '1px solid var(--glass-border)', marginBottom: '25px' }}>
                      <i className="fa-solid fa-circle-info" style={{ color: 'var(--p-blue)', fontSize: '18px', marginTop: '2px', flexShrink: 0 }}></i>
                      <p style={{ margin: 0, fontSize: '13px', color: 'var(--p-navy)', lineHeight: '1.5' }}>Si dejas el custodio en blanco, el equipo se registrará como <strong>&quot;En Bodega&quot;</strong> sin generar acta inicial.</p>
                    </div>

                    <div className="premium-field">
                      <label><i className="fa-solid fa-user-tag" style={{ color: 'var(--p-indigo)' }}></i> Funcionario Custodio <span style={{ fontWeight: '400', color: 'var(--p-slate)', fontSize: '11px' }}>(opcional)</span></label>
                      <select className="select-premium" name="custodio" value={formData.custodio} onChange={handleFormChange} style={{ width: '100%', height: '50px' }}>
                        <option value="">— Sin asignar / En bodega municipal —</option>
                        {funcionariosList.filter(f => f.estado_funcionario !== 'Desvinculado' && f.estado_funcionario !== 'Pendiente').map(f => (
                          <option key={f.id} value={f.id}>{f.nombre}</option>
                        ))}
                      </select>
                    </div>

                    {formData.custodio && (
                      <div style={{ border: '1px solid var(--glass-border)', background: 'var(--sidebar-accent)', padding: '22px', borderRadius: '14px', marginTop: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px', paddingBottom: '12px', borderBottom: '1px solid var(--glass-border)' }}>
                          <i className="fa-solid fa-file-contract" style={{ color: 'var(--p-amber)', fontSize: '16px' }}></i>
                          <span style={{ color: 'var(--p-navy)', fontWeight: '700', fontSize: '13px' }}>Parametrización de Acta Inicial</span>
                        </div>
                        <div className="form-row">
                          <div className="premium-field">
                            <label><i className="fa-solid fa-hashtag" style={{ color: 'var(--p-blue)' }}></i> Folio / Referencia</label>
                            <input
                              type="text"
                              value={referenciaActa}
                              onChange={(e) => setReferenciaActa(e.target.value)}
                              placeholder="Ej: Entrega Bienes"
                            />
                          </div>
                          <div className="premium-field">
                            <label><i className="fa-solid fa-file-lines" style={{ color: 'var(--p-emerald)' }}></i> Tipo de Documento</label>
                            <select className="select-premium" value={autoActaType} onChange={e => setAutoActaType(e.target.value)} style={{ width: '100%', height: '50px' }}>
                              <option value="recepcion">Acta de Recepción</option>
                              <option value="traslado">Acta de Traslado</option>
                              <option value="prestamo">Acta de Préstamo</option>
                            </select>
                          </div>
                        </div>
                        {autoActaType === 'prestamo' && (
                          <div className="premium-field" style={{ marginTop: '15px' }}>
                            <label><i className="fa-solid fa-calendar" style={{ color: 'var(--p-amber)' }}></i> Fecha de Devolución <span style={{ fontWeight: '400', color: 'var(--p-slate)', fontSize: '11px' }}>(opcional)</span></label>
                            <input
                              type="date"
                              value={fechaDevolucion}
                              onChange={(e) => setFechaDevolucion(e.target.value)}
                              style={{ width: '100%', height: '50px' }}
                            />
                          </div>
                        )}
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '18px', padding: '12px', background: 'rgba(99, 102, 241, 0.05)', borderRadius: '8px', border: '1px solid var(--glass-border)' }}>
                      <i className="fa-solid fa-lightbulb" style={{ color: 'var(--p-amber)', fontSize: '12px' }}></i>
                      <p style={{ fontSize: '11px', color: 'var(--p-slate)', margin: 0 }}>Al guardar, se registrará el alta del bien y se abrirá el panel de firma si hay un custodio asignado.</p>
                    </div>

                    <div className="modal-footer-actions">
                      <button type="button" className="btn-secondary" onClick={handleCloseModal}>Cancelar</button>
                      <button type="submit" className="btn-primary"><i className="fa-solid fa-check"></i> Finalizar y Registrar</button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}

      {detailModalOpen && selectedEquipo && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal x-large">
            <div className="modal-header" style={{ marginBottom: '25px' }}>
              <h3 style={{ color: 'var(--p-navy)', margin: 0 }}>{selectedEquipo.modelo} ({selectedEquipo.codigo})</h3>
            </div>

            <div className="detail-body">
              <div className="detail-tabs">
                <button className={`detail-tab-btn ${activeTab === 'general' ? 'active' : ''}`} onClick={() => setActiveTab('general')}><i className="fa-solid fa-list"></i> Ficha</button>
                <button className={`detail-tab-btn ${activeTab === 'responsabilidad' ? 'active' : ''}`} onClick={() => setActiveTab('responsabilidad')}><i className="fa-solid fa-user-tie"></i> Custodia</button>
                <button className={`detail-tab-btn ${activeTab === 'tecnico' ? 'active' : ''}`} onClick={() => { setActiveTab('tecnico'); fetchMantenimiento(selectedEquipo.id); }}><i className="fa-solid fa-screwdriver-wrench"></i> Soporte Téc.</button>
                <button className={`detail-tab-btn ${activeTab === 'historial' ? 'active' : ''}`} onClick={() => setActiveTab('historial')}><i className="fa-solid fa-clock-rotate-left"></i> Línea de Vida</button>
                <button className={`detail-tab-btn ${activeTab === 'actas' ? 'active' : ''}`} onClick={() => setActiveTab('actas')}><i className="fa-solid fa-file-contract"></i> Actas</button>
                <button className={`detail-tab-btn ${activeTab === 'identificacion' ? 'active' : ''}`} onClick={() => setActiveTab('identificacion')}><i className="fa-solid fa-qrcode"></i> QR</button>
              </div>

              <div className="modal-scroll-area">
                {activeTab === 'general' && (
                  <div className="tab-pane">
                    <div className="detail-info-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
                      <div className="info-main-details">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                          <div className="info-box">
                            <strong><i className="fa-solid fa-laptop" style={{ color: 'var(--p-indigo)', marginRight: '6px' }}></i> Modelo</strong>
                            <span>{selectedEquipo.modelo}</span>
                          </div>
                          <div className="info-box">
                            <strong><i className="fa-solid fa-tag" style={{ color: 'var(--p-emerald)', marginRight: '6px' }}></i> Categoría</strong>
                            <span>{selectedEquipo.categoria || 'N/A'}</span>
                          </div>
                          <div className="info-box">
                            <strong><i className="fa-solid fa-barcode" style={{ color: 'var(--p-blue)', marginRight: '6px' }}></i> ID de Inventario</strong>
                            <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--p-blue)' }}>{selectedEquipo.codigo}</span>
                          </div>
                          <div className="info-box">
                            <strong><i className="fa-solid fa-signal" style={{ color: 'var(--p-amber)', marginRight: '6px' }}></i> Estado de Operación</strong>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '5px' }}>
                              <span className={`badge status-${(selectedEquipo.estado || 'baja').toLowerCase().replace(' ', '-')}`}>{selectedEquipo.estado}</span>
                              <select
                                className="select-premium"
                                value={selectedEquipo.estado}
                                onChange={(e) => handleChangeStatus(selectedEquipo.id, e.target.value)}
                                style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid var(--glass-border)', fontSize: '13px', flex: 1, outline: 'none' }}
                              >
                                <option value="Sin uso">Sin uso</option>
                                <option value="En servicio">En servicio</option>
                                <option value="En mantenimiento">En mantenimiento</option>
                                <option value="En préstamo">En préstamo</option>
                                <option value="Extraviado">Extraviado</option>
                                <option value="Sustraído">Sustraído</option>
                                <option value="Dado de baja">Dado de baja</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{ 
                        background: 'var(--card-bg)', padding: '18px', borderRadius: '16px', 
                        border: '1px solid var(--glass-border)', display: 'flex', flexDirection: 'column', gap: '14px'
                      }}>
                        <strong style={{ fontSize: '12px', color: 'var(--p-slate)', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <i className="fa-solid fa-camera" style={{ color: 'var(--p-blue)' }}></i> Evidencia de Alta
                        </strong>
                        
                        {selectedEquipo.foto_verificacion_fisica ? (
                          <div style={{ width: '100%', height: '140px', position: 'relative' }}>
                            <img 
                              src={selectedEquipo.foto_verificacion_fisica} 
                              alt="Foto de alta" 
                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)' }}
                            />
                            <div style={{ position: 'absolute', bottom: '10px', right: '10px', background: 'var(--modal-overlay)', padding: '4px 10px', borderRadius: '6px', fontSize: '10px', color: 'white', border: '1px solid var(--glass-border)', backdropFilter: 'blur(4px)' }}>
                              Foto de Registro
                            </div>
                          </div>
                        ) : (
                          <div style={{ width: '100%', height: '140px', background: 'var(--sidebar-accent)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--p-slate)', fontSize: '11px', border: '1px dashed var(--glass-border)' }}>
                            Sin foto de alta
                          </div>
                        )}

                        <div style={{ display: 'flex', gap: '10px' }}>
                          <div style={{ flex: 1, padding: '12px 10px', background: 'var(--sidebar-accent)', borderRadius: '12px', border: '1px solid var(--glass-border)', textAlign: 'center' }}>
                            <i className={`fa-solid ${selectedEquipo.verificacion_operativa ? 'fa-circle-check' : 'fa-circle-xmark'}`} style={{ color: selectedEquipo.verificacion_operativa ? 'var(--p-emerald)' : 'var(--p-rose)', marginBottom: '8px', fontSize: '18px' }}></i>
                            <div style={{ fontSize: '10px', fontWeight: '700', color: 'var(--p-navy)' }}>Operativo</div>
                          </div>
                          <div style={{ flex: 1, padding: '12px 10px', background: 'var(--sidebar-accent)', borderRadius: '12px', border: '1px solid var(--glass-border)', textAlign: 'center' }}>
                            <i className={`fa-solid ${selectedEquipo.verificacion_fisica ? 'fa-circle-check' : 'fa-circle-xmark'}`} style={{ color: selectedEquipo.verificacion_fisica ? 'var(--p-emerald)' : 'var(--p-rose)', marginBottom: '8px', fontSize: '18px' }}></i>
                            <div style={{ fontSize: '10px', fontWeight: '700', color: 'var(--p-navy)' }}>Físico</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div style={{ background: 'var(--card-bg)', border: '1px solid var(--glass-border)', padding: '18px', borderRadius: '12px', marginTop: '15px' }}>
                      <strong style={{ fontSize: '12px', color: 'var(--p-slate)', display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                        <i className="fa-solid fa-clipboard-list" style={{ color: 'var(--p-amber)' }}></i> Observaciones de Registro
                      </strong>
                      <p style={{ margin: 0, color: 'var(--p-navy)', lineHeight: '1.5', fontSize: '13px' }}>{selectedEquipo.detalle || 'Sin observaciones registradas.'}</p>
                    </div>
                  </div>
                )}

                {activeTab === 'responsabilidad' && (
                  <div className="tab-pane">
                    {/* Tarjeta de custodio actual */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '20px', background: 'var(--card-bg)', borderRadius: '14px', border: '1px solid var(--glass-border)', marginBottom: '25px' }}>
                      <div style={{ width: '48px', height: '48px', borderRadius: '14px', background: selectedEquipo.custodio_nombre ? 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))' : 'var(--sidebar-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '20px', flexShrink: 0, border: selectedEquipo.custodio_nombre ? 'none' : '1px dashed var(--glass-border)' }}>
                        <i className={`fa-solid ${selectedEquipo.custodio_nombre ? 'fa-user-tie' : 'fa-warehouse'}`}></i>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '11px', color: 'var(--p-slate)', fontWeight: '600', marginBottom: '4px' }}>Custodio Actual</div>
                        <div style={{ fontWeight: '800', fontSize: '16px', color: 'var(--p-navy)' }}>{selectedEquipo.custodio_nombre || 'En Bodega Municipal'}</div>
                        <div style={{ fontSize: '12px', color: 'var(--p-slate)', marginTop: '2px' }}>{selectedEquipo.custodio_rut || 'Sin RUT'} · {selectedEquipo.custodio_cargo || 'Sin cargo'}</div>
                      </div>
                      <span className={`badge ${selectedEquipo.custodio_nombre ? 'status-en-servicio' : 'status-sin-uso'}`}>{selectedEquipo.custodio_nombre ? 'Asignado' : 'Disponible'}</span>
                    </div>

                    {/* Formulario de transferencia */}
                    <div style={{ border: '1px solid var(--glass-border)', padding: '22px', borderRadius: '14px', background: 'var(--sidebar-accent)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', paddingBottom: '14px', borderBottom: '1px solid var(--glass-border)' }}>
                        <i className="fa-solid fa-right-left" style={{ color: 'var(--p-indigo)', fontSize: '16px' }}></i>
                        <span style={{ fontWeight: '700', fontSize: '14px', color: 'var(--p-navy)' }}>Asignar Nueva Custodia</span>
                      </div>
                      <div className="form-row">
                        <div className="premium-field">
                          <label><i className="fa-solid fa-user-tag" style={{ color: 'var(--p-indigo)' }}></i> Funcionario Destino</label>
                          <select className="select-premium" value={nuevoCustodio} onChange={e => setNuevoCustodio(e.target.value)} style={{ width: '100%', height: '48px' }}>
                            <option value="">— Devolver a Bodega —</option>
                            {funcionariosList.filter(f => f.estado_funcionario !== 'Desvinculado' && f.estado_funcionario !== 'Pendiente').map(f => (
                              <option key={f.id} value={f.id}>{f.nombre}</option>
                            ))}
                          </select>
                        </div>
                        <div className="premium-field">
                          <label><i className="fa-solid fa-pencil" style={{ color: 'var(--p-amber)' }}></i> Referencia / Nota</label>
                          <input type="text" value={notaTransferencia} onChange={e => setNotaTransferencia(e.target.value)} placeholder="Ej: Cambio de oficina..." />
                        </div>
                      </div>
                      {nuevoCustodio && (
                        <div className="form-row" style={{ background: 'var(--bg-subtle)', padding: '15px', borderRadius: '12px', border: '1px solid var(--glass-border)' }}>
                          <div className="premium-field">
                            <label><i className="fa-solid fa-file-contract" style={{ color: 'var(--p-emerald)' }}></i> Tipo de Acta a Generar</label>
                            <div style={{ display: 'flex', gap: '10px' }}>
                              <input type="text" value={referenciaActa} onChange={e => setReferenciaActa(e.target.value)} placeholder="Folio/Referencia" />
                              <select className="select-premium" value={autoActaType} onChange={e => setAutoActaType(e.target.value)} style={{ height: '48px' }}>
                                {selectedEquipo?.custodio_id
                                  ? <>
                                      <option value="traslado">Traslado a otro funcionario</option>
                                      <option value="prestamo">Préstamo temporal</option>
                                    </>
                                  : <>
                                      <option value="recepcion">Recepción inicial</option>
                                      <option value="traslado">Traslado</option>
                                      <option value="prestamo">Préstamo temporal</option>
                                    </>
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                      )}
                      {!nuevoCustodio && selectedEquipo?.custodio_id && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px', background: 'rgba(99, 102, 241, 0.05)', borderRadius: '10px', border: '1px solid var(--glass-border)', marginTop: '10px' }}>
                          <i className="fa-solid fa-lightbulb" style={{ color: 'var(--p-amber)', fontSize: '12px', flexShrink: 0 }}></i>
                          <span style={{ fontSize: '12px', color: 'var(--p-slate)' }}>Deja el campo en blanco y confirma para generar acta de <strong style={{ color: 'var(--p-navy)' }}>Devolución a Bodega</strong>.</span>
                        </div>
                      )}
                      <button className="btn-primary" style={{ width: '100%', marginTop: '15px', display: 'flex', justifyContent: 'center', height: '48px' }} onClick={handleTransferCustodio} disabled={isTransferring}>
                        {isTransferring ? <><i className="fa-solid fa-circle-notch fa-spin"></i> Guardando...</> : <><i className="fa-solid fa-arrow-right-arrow-left" style={{ marginRight: '8px' }}></i> Confirmar Transferencia</>}
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === 'historial' && (
                  <div className="tab-pane">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="fa-solid fa-clock-rotate-left" style={{ color: 'var(--p-indigo)', fontSize: '16px' }}></i>
                        <h3 style={{ fontSize: '15px', color: 'var(--p-navy)', margin: 0 }}>Historial de Movimientos</h3>
                        {historial.length > 0 && <span style={{ fontSize: '10px', color: 'var(--p-blue)', background: 'var(--sidebar-accent)', padding: '3px 10px', borderRadius: '12px', border: '1px solid var(--glass-border)', fontWeight: '700' }}>{historial.length}</span>}
                      </div>
                      {historial.length > HISTORY_PER_PAGE && (
                        <div className="p-pagination-controls" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <button 
                            className="btn-secondary" 
                            style={{ padding: '4px 10px', fontSize: '11px' }}
                            disabled={historyPage === 1}
                            onClick={() => setHistoryPage(p => p - 1)}
                          >
                            <i className="fa-solid fa-chevron-left"></i>
                          </button>
                          <span style={{ fontSize: '11px', color: 'var(--p-slate)', fontWeight: 'bold' }}>
                            {historyPage} / {Math.ceil(historial.length / HISTORY_PER_PAGE)}
                          </span>
                          <button 
                            className="btn-secondary" 
                            style={{ padding: '4px 10px', fontSize: '11px' }}
                            disabled={historyPage >= Math.ceil(historial.length / HISTORY_PER_PAGE)}
                            onClick={() => setHistoryPage(p => p + 1)}
                          >
                            <i className="fa-solid fa-chevron-right"></i>
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="timeline-container">
                      {isHistorialLoading ? (
                        <div style={{ textAlign: 'center', color: 'var(--p-slate)' }}>Obteniendo historial...</div>
                      ) : historial.length > 0 ? (
                        historial.slice((historyPage - 1) * HISTORY_PER_PAGE, historyPage * HISTORY_PER_PAGE).map(h => {
                          const parsed = parseHistoryDetail(h.detalle);
                          return (
                            <div key={h.id} className="timeline-item">
                              <div className="timeline-dot" style={{ background: parsed.color }}></div>
                              <div className="timeline-content" style={{ cursor: 'pointer' }} onClick={() => setSelectedHistoryEvent(h)}>
                                <div className="timeline-header">
                                  <span className="timeline-date"><i className="fa-regular fa-calendar"></i> {h.fecha}</span>
                                  <span className="timeline-user"><i className="fa-solid fa-user-pen"></i> {h.usuario_uid}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <p className="timeline-detail" style={{ fontWeight: '700', fontSize: '13px' }}>
                                    <i className={parsed.icon} style={{ marginRight: '8px', color: parsed.color }}></i>
                                    {parsed.tipo}
                                  </p>
                                  <div className="timeline-expand-btn-premium">
                                    <span>Ver Ficha</span>
                                    <i className="fa-solid fa-arrow-right-long"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="empty-history" style={{ textAlign: 'center', color: 'var(--p-slate)', padding: '30px' }}>Sin movimientos registrados.</div>
                      )}
                    </div>
                  </div>
                )}
                {activeTab === 'tecnico' && (
                  <div className="tab-pane">
                    <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="fa-solid fa-screwdriver-wrench" style={{ color: 'var(--p-indigo)', fontSize: '16px' }}></i>
                        <h3 style={{ fontSize: '15px', color: 'var(--p-navy)', margin: 0 }}>Bitácora de Mantenimiento</h3>
                        {mantenimientoHist.length > 0 && <span style={{ fontSize: '10px', color: 'var(--p-blue)', background: 'var(--sidebar-accent)', padding: '3px 10px', borderRadius: '12px', border: '1px solid var(--glass-border)', fontWeight: '700' }}>{mantenimientoHist.length}</span>}
                      </div>
                      <div style={{ fontSize: '11px', color: 'var(--p-slate)', background: 'var(--sidebar-accent)', padding: '6px 14px', borderRadius: '20px', border: '1px solid var(--glass-border)', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <i className="fa-solid fa-stethoscope" style={{ fontSize: '10px', color: 'var(--p-blue)' }}></i> Intervenciones técnicas
                      </div>
                    </div>
                    
                    <div className="maintenance-list" style={{ width: '100%' }}>
                      {isMaintLoading ? (
                        <div style={{ padding: '20px' }}><Skeleton width="100%" height="150px" /></div>
                      ) : mantenimientoHist.length > 0 ? (
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', maxHeight: '450px', overflowY: 'auto', paddingRight: '10px' }}>
                          {mantenimientoHist.map(m => (
                            <div key={m.id} style={{ background: 'var(--card-bg)', border: '1px solid var(--glass-border)', padding: '15px', borderRadius: '12px' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                <span style={{ fontSize: '11px', color: 'var(--p-blue)', fontWeight: 'bold' }}>{m.tipo}</span>
                                <span style={{ fontSize: '11px', color: 'var(--p-slate)' }}>{m.fecha_str}</span>
                              </div>
                              <p style={{ fontSize: '13px', color: 'var(--p-navy)', margin: '0 0 10px 0', lineHeight: '1.4' }}>{m.descripcion}</p>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid var(--glass-border)', paddingTop: '10px' }}>
                                <span style={{ fontSize: '11px', color: 'var(--p-slate)' }}>Técnico: <span style={{ color: 'var(--p-navy)' }}>{m.tecnico}</span></span>
                                <span style={{ color: 'var(--p-emerald)', fontWeight: 'bold', fontSize: '12px' }}>${parseFloat(m.costo).toLocaleString('es-CL')}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty-history" style={{ textAlign: 'center', color: 'var(--p-slate)', padding: '60px', background: 'var(--bg-subtle)', borderRadius: '12px', border: '1px solid var(--glass-border)' }}>
                          <i className="fa-solid fa-folder-open" style={{ fontSize: '30px', marginBottom: '15px', display: 'block', opacity: 0.5 }}></i>
                          No hay registros de mantenimiento para este activo.
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {activeTab === 'actas' && (
                  <div className="tab-pane">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                      <i className="fa-solid fa-file-contract" style={{ color: 'var(--p-indigo)', fontSize: '16px' }}></i>
                      <h3 style={{ fontSize: '15px', color: 'var(--p-navy)', margin: 0 }}>Documentos de Control</h3>
                      {actasArchivadas.length > 0 && <span style={{ fontSize: '10px', color: 'var(--p-blue)', background: 'var(--sidebar-accent)', padding: '3px 10px', borderRadius: '12px', border: '1px solid var(--glass-border)', fontWeight: '700' }}>{actasArchivadas.length}</span>}
                    </div>
                    {actasArchivadas.length > 0 ? (
                      <div className="table-responsive" style={{ maxHeight: '300px' }}>
                        <table className="data-table" style={{ fontSize: '12px' }}>
                          <thead>
                            <tr>
                              <th>Folio</th>
                              <th>Tipo</th>
                              <th>Fecha</th>
                              <th>Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {actasArchivadas.map(acta => (
                              <tr key={acta.id}>
                                <td><strong>#{String(acta.correlativo).padStart(4, '0')}</strong></td>
                                <td>{acta.tipo.toUpperCase()}</td>
                                <td>{acta.fecha_str || acta.fecha || '—'}</td>
                                <td>
                                  <button className="btn-secondary" style={{ padding: '6px 12px' }} onClick={() => {
                                    const extra = acta.data_json ? JSON.parse(acta.data_json) : null;
                                    handleGenerateActa(acta.tipo, selectedEquipo, extra, acta.correlativo);
                                  }}>
                                    Ver Copia
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="empty-history" style={{ padding: '40px' }}>No hay actas guardadas para este equipo.</div>
                    )}
                  </div>
                )}

                {activeTab === 'identificacion' && (
                  <div className="tab-pane">
                    <div style={{ background: 'var(--sidebar-accent)', padding: '30px', borderRadius: '16px', border: '1px solid var(--glass-border)', textAlign: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '22px' }}>
                        <i className="fa-solid fa-qrcode" style={{ color: 'var(--p-indigo)', fontSize: '18px' }}></i>
                        <h3 style={{ fontSize: '15px', color: 'var(--p-navy)', margin: 0 }}>Folio de Inventario Digital</h3>
                      </div>
                      <div style={{ display: 'inline-block', padding: '15px', border: '1px solid var(--glass-border)', borderRadius: '14px', background: 'white' }}>
                        <QRCodeCanvas
                          id="qr-gen"
                          value={`${window.location.protocol}//${window.location.host}/equipo/${selectedEquipo.codigo}`}
                          size={160}
                          level={"H"}
                          includeMargin={true}
                        />
                      </div>
                      <div style={{ marginTop: '8px', fontFamily: 'var(--font-mono)', fontSize: '12px', color: 'var(--p-blue)', fontWeight: '600' }}>{selectedEquipo.codigo}</div>
                      <div style={{ marginTop: '22px', display: 'flex', gap: '12px', justifyContent: 'center' }}>
                        <button className="btn-secondary" onClick={downloadQR}><i className="fa-solid fa-download" style={{ marginRight: '6px' }}></i> PNG</button>
                        <button className="btn-primary" onClick={handlePrintQR}><i className="fa-solid fa-print" style={{ marginRight: '6px' }}></i> Imprimir</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer-actions">
                <button type="button" className="btn-secondary" onClick={() => setDetailModalOpen(false)}>
                  <i className="fa-solid fa-xmark" style={{ marginRight: '6px' }}></i> Cerrar Consulta
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPrintPrepModal && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal" style={{ maxWidth: '800px', padding: '40px' }}>
            <div className="modal-header" style={{ marginBottom: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--glass-border)', paddingBottom: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'var(--sidebar-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--p-indigo)', border: '1px solid var(--glass-border)' }}>
                  <i className="fa-solid fa-file-signature"></i>
                </div>
                <h2 style={{ color: 'var(--p-navy)', margin: 0, fontSize: '22px' }}>
                  {prepData.actaType === 'mantenimiento' ? 'Evaluación Técnica' :
                    prepData.actaType === 'incidencia' ? 'Protocolo de Incidencia' : 'Preparación de Acta'}
                </h2>
              </div>
              <div style={{ display: 'flex', gap: '12px', background: 'var(--app-bg)', padding: '6px 12px', borderRadius: '30px', border: '1px solid var(--glass-border)' }}>
                <span style={{ fontSize: '9px', padding: '4px 12px', borderRadius: '15px', background: prepData.prepStep === 1 ? 'var(--p-blue)' : 'transparent', color: prepData.prepStep === 1 ? 'white' : 'var(--p-slate)', fontWeight: 'bold', transition: 'all 0.3s' }}>1. DETALLES</span>
                <span style={{ fontSize: '9px', padding: '4px 12px', borderRadius: '15px', background: prepData.prepStep === 2 ? 'var(--p-blue)' : 'transparent', color: prepData.prepStep === 2 ? 'white' : 'var(--p-slate)', fontWeight: 'bold', transition: 'all 0.3s' }}>2. FIRMAS</span>
              </div>
            </div>

            <div className="prep-wizard-body" style={{ minHeight: '420px' }}>
              {prepData.prepStep === 1 ? (
                <div className="animate-fade-in">
                  {prepData.actaType === 'prestamo' ? (
                    <div className="prestamo-setup-view" style={{ padding: '10px' }}>
                      <div className="eval-card-premium" style={{ background: 'var(--card-bg)', borderRadius: '20px', border: '1px solid var(--glass-border)', padding: '25px', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', gap: '15px', marginBottom: '25px' }}>
                          <div style={{ width: '45px', height: '45px', borderRadius: '12px', background: 'var(--sidebar-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--p-emerald)', fontSize: '20px', border: '1px solid var(--glass-border)' }}>
                            <i className="fa-solid fa-handshake"></i>
                          </div>
                          <div>
                            <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--p-navy)' }}>Detalles del Préstamo</h3>
                            <p style={{ margin: 0, fontSize: '13px', color: 'var(--p-slate)' }}>Registre quién recibe y cuándo devuelve</p>
                          </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                          <div className="input-group full-width">
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>Beneficiario (Funcionario):</label>
                            <select
                              className="select-premium"
                              style={{ width: '100%', height: '50px', borderRadius: '12px' }}
                              value={prepData.prestamoRecipient}
                              onChange={(e) => setPrepData({ ...prepData, prestamoRecipient: e.target.value })}
                            >
                              <option value="">Seleccione funcionario...</option>
                              {funcionariosList.map(f => (
                                <option key={f.id} value={f.id}>{f.nombre} ({f.cargo || 'Funcionario'})</option>
                              ))}
                            </select>
                          </div>
                          <div className="input-group full-width">
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>Fecha de Devolución:</label>
                            <input
                              type="date"
                              className="filter-select-premium"
                              style={{ width: '100%', height: '50px', borderRadius: '12px', background: 'var(--input-bg)', color: 'var(--p-navy)', border: '1px solid var(--glass-border)', padding: '0 15px' }}
                              value={prepData.prestamoFecha}
                              onChange={(e) => setPrepData({ ...prepData, prestamoFecha: e.target.value })}
                            />
                          </div>
                          <div className="input-group full-width" style={{ gridColumn: 'span 2' }}>
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>Notas/Observaciones del Préstamo:</label>
                            <textarea
                              className="filter-select-premium"
                              style={{ width: '100%', height: '80px', borderRadius: '12px', background: 'var(--input-bg)', color: 'var(--p-navy)', border: '1px solid var(--glass-border)', padding: '15px', resize: 'none' }}
                              placeholder="Ej: Se presta para operativo en terreno, devuélvalo limpio..."
                              value={prepData.observaciones}
                              onChange={(e) => setPrepData({ ...prepData, observaciones: e.target.value })}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer-actions" style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                        <button type="button" className="btn-secondary" style={{ height: '55px', padding: '0 25px', borderRadius: '15px' }} onClick={() => setShowPrintPrepModal(false)}>Cancelar</button>
                        <button
                          type="button"
                          className="btn-primary"
                          style={{ minWidth: '240px', height: '55px', borderRadius: '15px', background: 'var(--p-blue)', fontWeight: 'bold' }}
                          onClick={() => {
                            if (!prepData.prestamoRecipient) return alert('Debe seleccionar quién recibe el préstamo.');
                            if (!prepData.prestamoFecha) return alert('Debe indicar la fecha de devolución.');
                            setPrepData({ ...prepData, prepStep: 2 });
                          }}
                        >
                          Ir a Firmas <i className="fa-solid fa-arrow-right" style={{ marginLeft: '10px' }}></i>
                        </button>
                      </div>
                    </div>
                  ) : prepData.actaType === 'mantenimiento' ? (
                    <div className="maintenance-eval-view" style={{ padding: '10px' }}>
                      <div className="eval-card-premium" style={{ background: 'var(--card-bg)', borderRadius: '20px', border: '1px solid var(--glass-border)', padding: '25px', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px' }}>
                          <div style={{ width: '45px', height: '45px', borderRadius: '12px', background: 'var(--sidebar-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--p-blue)', fontSize: '20px', border: '1px solid var(--glass-border)' }}>
                            <i className="fa-solid fa-clipboard-check"></i>
                          </div>
                          <div>
                            <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--p-navy)' }}>Evaluación de Hardware</h3>
                            <p style={{ margin: 0, fontSize: '13px', color: 'var(--p-slate)' }}>Diagnóstico y registro de hallazgos técnicos</p>
                          </div>
                        </div>
                        <div className="input-group full-width" style={{ marginBottom: '25px' }}>
                          <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>Determinación Técnica:</label>
                          <select
                            className="select-premium"
                            style={{ width: '100%', height: '55px', borderRadius: '15px' }}
                            value={prepData.mantenimientoTipo}
                            onChange={(e) => setPrepData({ ...prepData, mantenimientoTipo: e.target.value })}
                          >
                            <option value="Reparación Interna">Reparación Interna (Soporte UDT)</option>
                            <option value="Servicio Técnico Externo">Envío a Servicio Técnico Externo</option>
                            <option value="Dado de baja">Irreparable - Dar de baja definitiva</option>
                          </select>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '25px' }}>
                          <div>
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>Evidencia Fotográfica:</label>
                            <PhotoCapture
                              id="maintenance-photo"
                              preview={prepData.mantenimientoEvidencia}
                              onCapture={(result) => setPrepData({ ...prepData, mantenimientoEvidencia: result })}
                              onClear={() => setPrepData({ ...prepData, mantenimientoEvidencia: null })}
                            />
                          </div>
                          <div>
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>Notas de Intervención:</label>
                            <textarea
                              value={prepData.mantenimientoNotas}
                              onChange={(e) => setPrepData({ ...prepData, mantenimientoNotas: e.target.value })}
                              style={{ width: '100%', height: '120px', borderRadius: '15px', background: 'var(--input-bg)', border: '1px solid var(--glass-border)', padding: '15px', color: 'var(--p-navy)', resize: 'none' }}
                              placeholder="Describa el problema detectado o la solución aplicada..."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer-actions" style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                        <button type="button" className="btn-secondary" style={{ height: '55px', padding: '0 30px', borderRadius: '15px' }} onClick={() => setShowPrintPrepModal(false)}>Cancelar</button>
                        <button type="button" className="btn-primary" style={{ minWidth: '240px', height: '55px', borderRadius: '15px' }} onClick={() => {
                          if (!prepData.mantenimientoNotas) return toast.warning('Por favor, ingresa las notas del diagnóstico.');
                          setPrepData({ ...prepData, prepStep: 2 });
                        }}>Continuar a Firmas <i className="fa-solid fa-arrow-right" style={{ marginLeft: '12px' }}></i></button>
                      </div>
                    </div>
                  ) : prepData.actaType === 'incidencia' ? (
                    <div className="incidencia-protocol-view" style={{ padding: '10px' }}>
                      <div style={{ background: 'var(--sidebar-accent)', border: '1px solid var(--glass-border)', padding: '25px', borderRadius: '20px', marginBottom: '20px' }}>
                        <h3 style={{ color: 'var(--p-navy)', fontSize: '18px', marginBottom: '15px' }}><i className="fa-solid fa-triangle-exclamation" style={{ color: 'var(--p-rose)', marginRight: '10px' }}></i>Protocolo de Seguridad</h3>
                        <div style={{ marginTop: '15px' }}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', padding: '15px', background: 'var(--bg-subtle)', borderRadius: '12px', border: '1px solid var(--glass-border)' }}>
                            <input type="checkbox" checked={prepData.uemActivated} onChange={(e) => setPrepData({ ...prepData, uemActivated: e.target.checked })} style={{ width: '20px', height: '20px', accentColor: 'var(--p-rose)' }} />
                            <span style={{ fontSize: '14px', color: 'var(--p-navy)' }}>Activar Protocolo UEM de recuperación institucional</span>
                          </label>
                        </div>
                        <div className="premium-field" style={{ marginTop: '20px' }}>
                          <label style={{ color: 'var(--p-slate)', fontSize: '11px', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>Relato del Suceso:</label>
                          <textarea value={prepData.mantenimientoNotas} onChange={(e) => setPrepData({ ...prepData, mantenimientoNotas: e.target.value })} style={{ width: '100%', height: '100px', borderRadius: '12px', background: 'var(--input-bg)', padding: '15px', color: 'var(--p-navy)', border: '1px solid var(--glass-border)' }} placeholder="Describa el evento..." />
                        </div>
                      </div>
                      <div className="modal-footer-actions" style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                        <button type="button" className="btn-secondary" style={{ height: '55px', padding: '0 30px', borderRadius: '15px' }} onClick={() => setShowPrintPrepModal(false)}>Cancelar</button>
                        <button type="button" className="btn-primary" style={{ minWidth: '240px', height: '55px', borderRadius: '15px', background: 'var(--p-rose)' }} onClick={() => {
                          if (!prepData.mantenimientoNotas) return toast.warning('Debe ingresar el relato de los hechos.');
                          setPrepData({ ...prepData, prepStep: 2 });
                        }}>Confirmar e Ir a Firmas <i className="fa-solid fa-signature" style={{ marginLeft: '12px' }}></i></button>
                      </div>
                    </div>
                  ) : (
                    <div className="general-prep-view" style={{ padding: '10px' }}>
                      <div className="eval-card-premium" style={{ background: 'var(--card-bg)', borderRadius: '20px', border: '1px solid var(--glass-border)', padding: '25px', marginBottom: '30px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px' }}>
                          <div style={{ width: '45px', height: '45px', borderRadius: '12px', background: 'var(--sidebar-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--p-indigo)', fontSize: '20px', border: '1px solid var(--glass-border)' }}>
                            <i className="fa-solid fa-clipboard-list"></i>
                          </div>
                          <div>
                            <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--p-navy)' }}>Estado y Hallazgos</h3>
                            <p style={{ margin: 0, fontSize: '13px', color: 'var(--p-slate)' }}>Defina la condición actual del activo</p>
                          </div>
                        </div>

                        <div className="input-group full-width" style={{ marginBottom: '25px' }}>
                          <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>ESTADO GENERAL DEL ACTIVO:</label>
                          <select
                            className="select-premium"
                            style={{ width: '100%', height: '55px', borderRadius: '15px' }}
                            value={prepData.estadoGeneral}
                            onChange={e => setPrepData({ ...prepData, estadoGeneral: e.target.value })}
                          >
                            <option value="CONFORME">CONFORME (Excelente estado)</option>
                            <option value="CONFORME CON OBSERVACIONES">CONFORME CON OBSERVACIONES</option>
                            <option value="INCONFORME">INCONFORME (Presenta fallas)</option>
                          </select>
                        </div>

                        {prepData.actaType === 'traslado' && (
                          <div className="input-group full-width" style={{ marginBottom: '25px' }}>
                            <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>EVIDENCIA FOTOGRÁFICA DEL TRASLADO (OBLIGATORIO):</label>
                            <PhotoCapture
                              id="traslado-photo"
                              preview={prepData.trasladoEvidencia}
                              onCapture={(result) => setPrepData({ ...prepData, trasladoEvidencia: result })}
                              onClear={() => setPrepData({ ...prepData, trasladoEvidencia: null })}
                            />
                          </div>
                        )}

                        <div className="input-group full-width">
                          <label style={{ fontSize: '11px', textTransform: 'uppercase', color: 'var(--p-slate)', fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>OBSERVACIONES ADICIONALES:</label>
                          <textarea
                            className="filter-select-premium"
                            style={{ width: '100%', height: '120px', borderRadius: '15px', background: 'var(--input-bg)', padding: '15px', color: 'var(--p-navy)', resize: 'none', border: '1px solid var(--glass-border)' }}
                            placeholder="Detalles específicos sobre la entrega o recepción del equipo..."
                            value={prepData.observaciones}
                            onChange={e => setPrepData({ ...prepData, observaciones: e.target.value })}
                          />
                        </div>
                      </div>

                      <div className="modal-footer-actions" style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                        <button type="button" className="btn-secondary" style={{ height: '55px', padding: '0 30px', borderRadius: '15px' }} onClick={() => setShowPrintPrepModal(false)}>Cancelar</button>
                        <button
                          type="button"
                          className="btn-primary"
                          style={{ minWidth: '240px', height: '55px', borderRadius: '15px', background: 'var(--p-blue)', fontWeight: 'bold' }}
                          onClick={() => {
                            if (prepData.actaType === 'traslado' && !prepData.trasladoEvidencia) {
                              return toast.warning('Debe adjuntar la evidencia fotográfica del bien para proceder con el traslado.');
                            }
                            setPrepData({ ...prepData, prepStep: 2 });
                          }}
                        >
                          Avanzar a Firmas <i className="fa-solid fa-arrow-right" style={{ marginLeft: '12px' }}></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="animate-fade-in">
                  <div style={{
                    padding: '25px',
                    background: 'var(--sidebar-accent)',
                    borderRadius: '20px',
                    border: '1px solid var(--glass-border)',
                    marginBottom: '30px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ color: 'var(--p-navy)', fontSize: '15px', fontWeight: '800', margin: 0, textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                        <i className="fa-solid fa-file-invoice" style={{ marginRight: '12px', color: 'var(--p-blue)' }}></i>
                        Resumen de Preparación Final
                      </h3>
                      <span className="p-badge" style={{ fontSize: '10px', background: 'var(--sidebar-accent)', color: 'var(--p-navy)', padding: '4px 12px', borderRadius: '12px', border: '1px solid var(--glass-border)' }}>PASO FINAL</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '10px', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '15px' }}>
                      <p style={{ fontSize: '13px', color: 'var(--p-slate)', margin: 0 }}>Tipo de Documento: <strong style={{ color: 'var(--p-navy)' }}>{prepData.actaType?.toUpperCase()}</strong></p>
                      <p style={{ fontSize: '13px', color: 'var(--p-slate)', margin: 0 }}>Estado del Proceso: <strong style={{ color: 'var(--p-navy)' }}>Listo para Firma</strong></p>
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '30px' }}>
                    <div className="signature-container" style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                        <label style={{ fontSize: '12px', color: 'var(--p-navy)', fontWeight: '700', textTransform: 'uppercase' }}>Firma Responsable Inventario:</label>
                        <button
                          onClick={() => sigPadEncargado.current.clear()}
                          style={{ background: 'none', border: 'none', color: '#f43f5e', cursor: 'pointer', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '5px' }}
                        >
                          <i className="fa-solid fa-rotate-left"></i> Limpiar
                        </button>
                      </div>
                      <div className="sig-canvas-wrapper" style={{
                        background: '#ffffff',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        border: '2px solid rgba(56, 189, 248, 0.3)',
                        boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.1)',
                        position: 'relative'
                      }}>
                        <SignatureCanvas
                          ref={sigPadEncargado}
                          penColor='#1a1a2e'
                          canvasProps={{ width: 330, height: 170, className: 'sigCanvas' }}
                        />
                        <div style={{ position: 'absolute', bottom: '10px', right: '15px', color: 'rgba(56, 189, 248, 0.3)', fontSize: '11px', pointerEvents: 'none' }}>Sello Digital</div>
                      </div>
                    </div>

                    {prepData.actaType !== 'ingreso_bodega' ? (
                      <div className="signature-container" style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                          <label style={{ fontSize: '12px', color: 'var(--p-navy)', fontWeight: '700', textTransform: 'uppercase' }}>
                            {prepData.mantenimientoTipo === 'Dado de baja' ? 'Validación Técnica (TD):' : 'Firma Funcionario (Custodio):'}
                          </label>
                          <button
                            onClick={() => sigPadCustodio.current.clear()}
                            style={{ background: 'none', border: 'none', color: '#f43f5e', cursor: 'pointer', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '5px' }}
                          >
                            <i className="fa-solid fa-rotate-left"></i> Limpiar
                          </button>
                        </div>
                        <div className="sig-canvas-wrapper" style={{
                          background: '#ffffff',
                          borderRadius: '16px',
                          overflow: 'hidden',
                          border: '2px solid rgba(56, 189, 248, 0.3)',
                          boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.1)',
                          position: 'relative'
                        }}>
                          <SignatureCanvas
                            ref={sigPadCustodio}
                            penColor='#1a1a2e'
                            canvasProps={{ width: 330, height: 170, className: 'sigCanvas' }}
                          />
                          <div style={{ position: 'absolute', bottom: '10px', right: '15px', color: 'rgba(56, 189, 248, 0.3)', fontSize: '11px', pointerEvents: 'none' }}>Verificación</div>
                        </div>
                      </div>
                    ) : (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px dashed var(--glass-border)',
                        borderRadius: '16px',
                        padding: '20px',
                        background: 'rgba(255,255,255,0.02)'
                      }}>
                        <i className="fa-solid fa-user-slash" style={{ fontSize: '24px', marginBottom: '10px', opacity: 0.5, color: 'var(--p-slate)' }}></i>
                        <span style={{ color: 'var(--p-slate)', fontSize: '13px' }}>No se requiere firma de custodio</span>
                      </div>
                    )}
                  </div>

                  <div className="modal-footer-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '20px' }}>
                    <button type="button" className="btn-secondary" onClick={() => setPrepData({ ...prepData, prepStep: 1 })} style={{ minWidth: '150px' }}>
                      <i className="fa-solid fa-arrow-left"></i> Volver
                    </button>
                    <button
                      type="button"
                      className="btn-primary"
                      style={{ minWidth: '220px' }}
                      onClick={async () => {
                        const isIngresoBodega = prepData.actaType === 'ingreso_bodega';
                        if (sigPadEncargado.current.isEmpty()) return toast.warning('La firma del Responsable de Inventario es obligatoria.');
                        if (!isIngresoBodega && sigPadCustodio.current.isEmpty()) return toast.warning('La firma del Funcionario es obligatoria para este tipo de acta.');

                        let signatureImgEncargado;
                        let signatureImgCustodio;

                        const getBlackSignature = (sigPad) => {
                          if (!sigPad || sigPad.isEmpty()) return null;
                          // El lápiz ya es oscuro (#1a1a2e), solo añadimos fondo blanco explícito
                          const srcCanvas = sigPad.getTrimmedCanvas();
                          const outCanvas = document.createElement('canvas');
                          outCanvas.width  = srcCanvas.width  + 20;
                          outCanvas.height = srcCanvas.height + 20;
                          const ctx = outCanvas.getContext('2d');
                          ctx.fillStyle = '#ffffff';
                          ctx.fillRect(0, 0, outCanvas.width, outCanvas.height);
                          ctx.drawImage(srcCanvas, 10, 10);
                          return outCanvas.toDataURL('image/png');
                        };

                        try {
                          signatureImgEncargado = getBlackSignature(sigPadEncargado.current);
                          signatureImgCustodio = isIngresoBodega ? null : getBlackSignature(sigPadCustodio.current);
                        } catch (e) {
                          console.error('Error processing high-res signatures:', e);
                          signatureImgEncargado = sigPadEncargado.current.getCanvas().toDataURL('image/png');
                          signatureImgCustodio = isIngresoBodega ? null : sigPadCustodio.current.getCanvas().toDataURL('image/png');
                        }

                        let finalEquipoToPrint = prepData.equipoToPrint;
                        try {
                          if (prepData.pendingAction === 'transfer') {
                            const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/custodio`, { credentials: 'include', 
                              method: 'PATCH',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ ...prepData.pendingPayload, evidencia: prepData.trasladoEvidencia })
                            });
                            if (!resp.ok) throw new Error('Error al transferir equipo');

                            const freshListResp = await fetch(`${apiBase}/api/equipos?clase=${currentClase}`, { credentials: 'include' });
                            const updatedEquipos = await freshListResp.json();
                            finalEquipoToPrint = updatedEquipos.find(e => e.id === prepData.equipoToPrint.id);
                          } else if (prepData.pendingAction === 'status_prestamo') {
                            const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/estado`, { credentials: 'include', 
                              method: 'PATCH',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                nuevoEstado: 'En préstamo',
                                fechaDevolucion: prepData.prestamoFecha,
                                custodio_id: prepData.prestamoRecipient,
                                mantenimientoNotas: prepData.observaciones,
                                usuario: JSON.parse(localStorage.getItem('user') || '{}').id || 'Sistema'
                              })
                            });
                            if (!resp.ok) throw new Error('Error al registrar préstamo');
                            const freshListResp = await fetch(`${apiBase}/api/equipos?clase=${currentClase}`, { credentials: 'include' });
                            const updatedEquipos = await freshListResp.json();
                            finalEquipoToPrint = updatedEquipos.find(e => e.id === prepData.equipoToPrint.id);
                          } else if (prepData.pendingAction === 'status_mantenimiento') {
                            const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/estado`, { credentials: 'include', 
                              method: 'PATCH',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                nuevoEstado: prepData.mantenimientoTipo === 'Dado de baja' ? 'Dado de baja' : 'En mantenimiento',
                                mantenimientoTipo: prepData.mantenimientoTipo,
                                mantenimientoNotas: prepData.mantenimientoNotas,
                                mantenimientoEvidencia: prepData.mantenimientoEvidencia,
                                usuario: JSON.parse(localStorage.getItem('user') || '{}').id || 'Sistema'
                              })
                            });
                            if (!resp.ok) throw new Error('Error al registrar mantenimiento');

                            const freshListResp = await fetch(`${apiBase}/api/equipos?clase=${currentClase}`, { credentials: 'include' });
                            const freshDataList = await freshListResp.json();
                            finalEquipoToPrint = freshDataList.find(e => e.id === prepData.equipoToPrint.id);
                          } else if (prepData.pendingAction === 'status_incidencia') {
                            const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/estado`, { credentials: 'include', 
                              method: 'PATCH',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                nuevoEstado: prepData.pendingPayload.nuevoEstado,
                                mantenimientoTipo: prepData.mantenimientoTipo,
                                mantenimientoNotas: `[PROTOCOLO UEM ACTIVADO: ${prepData.uemActivated ? 'SI' : 'NO'}] - ${prepData.mantenimientoNotas}`,
                                usuario: JSON.parse(localStorage.getItem('user') || '{}').id || 'Sistema'
                              })
                            });
                            if (!resp.ok) throw new Error('Error al registrar incidencia de seguridad');

                            const freshListResp = await fetch(`${apiBase}/api/equipos?clase=${currentClase}`, { credentials: 'include' });
                            const freshDataList = await freshListResp.json();
                            finalEquipoToPrint = freshDataList.find(e => e.id === prepData.equipoToPrint.id);
                          } else if (prepData.pendingAction === 'transfer_and_finalize_solicitud') {
                            const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/custodio`, { credentials: 'include', 
                              method: 'PATCH',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                nuevoCustodio: prepData.pendingPayload.nuevoCustodio,
                                nota: prepData.pendingPayload.nota,
                                evidencia: prepData.evidencia,
                                usuario: JSON.parse(localStorage.getItem('user') || '{}').id || 'Sistema'
                              })
                            });
                            if (!resp.ok) throw new Error('Error al registrar transferencia de custodio');

                            const solResp = await fetch(`${apiBase}/api/solicitudes/${prepData.pendingPayload.solicitudId}`, { credentials: 'include', 
                              method: 'PATCH',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ 
                                nuevoEstado: 'Finalizada', 
                                equipo_asignado: prepData.pendingPayload.equipoAsignadoStr 
                              })
                            });
                            if (!solResp.ok) throw new Error('Error al finalizar solicitud');

                            const freshListResp = await fetch(`${apiBase}/api/equipos?clase=${currentClase}`, { credentials: 'include' });
                            const freshDataList = await freshListResp.json();
                            finalEquipoToPrint = freshDataList.find(e => e.id === prepData.equipoToPrint.id);
                            
                            const freshSol = await fetch(`${apiBase}/api/solicitudes`, { credentials: 'include' });
                            if (freshSol.ok) {
                               const data = await freshSol.json();
                               setEntregas(data.filter(s => s.estado === 'Aprobada por Jefatura' || s.estado === 'Pendiente de Firma'));
                            }
                          }
                        } catch (err) {
                          toast.error('Error al guardar los datos en el servidor. El acta no se generará.');
                          console.error(err);
                          return;
                        }

                        const finalDataForActa = { 
                          ...prepData, 
                          signatureCustodio: signatureImgCustodio, 
                          signatureEncargado: signatureImgEncargado,
                          evidencia: prepData.trasladoEvidencia || prepData.mantenimientoEvidencia 
                        };
                        setShowPrintPrepModal(false);
                        const equipoUsedForActa = prepData.actaType === 'devolucion' ? prepData.equipoToPrint : finalEquipoToPrint;
                        await handleGenerateActa(prepData.actaType, equipoUsedForActa, finalDataForActa);

                        fetchEquipos();

                        if (finalEquipoToPrint) {
                          fetch(`${apiBase}/api/equipos/${finalEquipoToPrint.id}/historial`, { credentials: 'include' })
                            .then(h => h.json())
                            .then(setHistorial)
                            .catch(console.error);
                        }

                        if (prepData.pendingAction === 'transfer') {
                          setNotaTransferencia('');
                          setPrepData(prev => ({ ...prev, trasladoEvidencia: null }));
                        }
                        if (prepData.pendingAction === 'create') {
                          setFormData({
                            codigo: '',
                            modelo: '',
                            categoria: currentCategorias[0]?.value || '',
                            estado: 'Sin uso',
                            custodio: '',
                            detalle: '',
                            clase: currentClase,
                            verificacion_operativa: false,
                            verificacion_fisica: false,
                            foto_verificacion_fisica: null
                          });
                        }
                      }}
                    >
                      Finalizar Documento e Imprimir
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {isCategoryModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal" style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h3>Gestionar Categorías: {currentClase}s</h3>
            </div>

            <div className="crud-form">
              <div className="premium-field">
                <label>Nueva Categoría para {currentClase}</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="text"
                    value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                    placeholder="Ej: Drones, Cámaras IP..."
                    style={{ flex: 1 }}
                  />
                  <button className="btn-primary" onClick={handleAddCategory}>Agregar</button>
                </div>
              </div>

              <div style={{ marginTop: '20px' }}>
                <label>Categorías Existentes ({currentClase}s)</label>
                <div style={{
                  maxHeight: '200px',
                  overflowY: 'auto',
                  background: 'var(--bg-subtle)',
                  borderRadius: '12px',
                  padding: '10px',
                  marginTop: '10px',
                  border: '1px solid var(--glass-border)'
                }}>
                  {dynamicCategorias.length === 0 ? (
                    <p style={{ color: 'var(--p-slate)', fontSize: '13px' }}>No hay categorías registradas.</p>
                  ) : (
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {dynamicCategorias.map(cat => (
                        <li key={cat.id} style={{
                          padding: '8px 12px',
                          borderBottom: '1px solid rgba(255,255,255,0.05)',
                          display: 'flex',
                          justifyContent: 'space-between',
                          color: 'var(--p-navy)',
                          fontSize: '14px'
                        }}>
                          {cat.nombre}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer-actions">
              <button className="btn-secondary" onClick={() => setIsCategoryModalOpen(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {isStatusQuickModalOpen && statusTarget && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal" style={{ maxWidth: '420px' }}>
            {/* Header con ícono */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '25px', paddingBottom: '18px', borderBottom: '1px solid var(--glass-border)' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '12px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '18px', flexShrink: 0 }}>
                <i className="fa-solid fa-arrows-rotate"></i>
              </div>
              <div>
                <h3 style={{ margin: 0, color: 'var(--p-navy)', fontSize: '17px' }}>Actualizar Estado</h3>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--p-slate)' }}>Cambio inmediato de estado operativo</p>
              </div>
            </div>

            {/* Tarjeta del equipo */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px', background: 'var(--sidebar-accent)', borderRadius: '12px', border: '1px solid var(--glass-border)', marginBottom: '24px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'var(--card-bg)', border: '1px solid var(--glass-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--p-blue)', fontSize: '16px', flexShrink: 0 }}>
                <i className="fa-solid fa-laptop"></i>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: '700', fontSize: '14px', color: 'var(--p-navy)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{statusTarget.modelo}</div>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--p-blue)', background: 'var(--card-bg)', padding: '2px 8px', borderRadius: '6px', border: '1px solid var(--glass-border)' }}>{statusTarget.codigo}</span>
              </div>
            </div>

            <div className="premium-field">
              <label><i className="fa-solid fa-signal" style={{ color: 'var(--p-indigo)' }}></i> Nuevo Estado</label>
              <select
                className="select-premium"
                style={{ width: '100%', height: '50px' }}
                defaultValue={statusTarget.estado}
                onChange={(e) => {
                  const val = e.target.value;
                  handleChangeStatus(statusTarget.id, val);
                  setIsStatusQuickModalOpen(false);
                  setStatusTarget(null);
                  setFormData(prev => ({ ...prev, _tempEstado: null }));
                }}
              >
                <option value="Sin uso">Sin uso</option>
                <option value="En servicio">En servicio</option>
                <option value="En mantenimiento">En mantenimiento</option>
                <option value="En préstamo">En préstamo</option>
                <option value="Extraviado">Extraviado</option>
                <option value="Sustraído">Sustraído</option>
                <option value="Dado de baja">Dado de baja</option>
              </select>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '16px', padding: '12px', background: 'rgba(99, 102, 241, 0.05)', borderRadius: '8px', border: '1px solid var(--glass-border)' }}>
              <i className="fa-solid fa-lightbulb" style={{ color: 'var(--p-amber)', fontSize: '12px', flexShrink: 0 }}></i>
              <p style={{ fontSize: '11px', color: 'var(--p-slate)', margin: 0 }}>El cambio se aplicará inmediatamente al seleccionar.</p>
            </div>

            <div className="modal-footer-actions">
              <button className="btn-secondary" onClick={() => { setIsStatusQuickModalOpen(false); setStatusTarget(null); }} style={{ width: '100%', justifyContent: 'center' }}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {selectedHistoryEvent && (
        <div className="modal-overlay" style={{ zIndex: 11000 }}>
          <div className="modal-content premium-modal animate-scale-in" style={{ 
            maxWidth: '600px', 
            padding: 0, 
            overflow: 'hidden',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {(() => {
              const parsed = parseHistoryDetail(selectedHistoryEvent.detalle);
              return (
                <>
                  <div style={{ 
                    padding: '25px 30px', 
                    background: `linear-gradient(to bottom, ${parsed.color}15, transparent)`,
                    borderBottom: '1px solid rgba(255,255,255,0.05)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{ 
                        width: '50px', 
                        height: '50px', 
                        borderRadius: '15px', 
                        background: parsed.color, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        boxShadow: `0 0 20px ${parsed.color}40`
                      }}>
                        <i className={parsed.icon} style={{ fontSize: '20px', color: 'var(--p-navy)' }}></i>
                      </div>
                      <div>
                        <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--p-navy)' }}>{parsed.tipo}</h3>
                        <span style={{ fontSize: '12px', color: 'var(--p-slate)' }}>#{selectedHistoryEvent.id}</span>
                      </div>
                    </div>
                    <button className="action-button-glass" onClick={() => setSelectedHistoryEvent(null)}>
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>

                  <div className="custom-scrollbar" style={{ padding: '30px', overflowY: 'auto', flex: 1 }}>
                    <div className="detail-info-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
                      <div className="info-box" style={{ background: 'rgba(255,255,255,0.02)' }}>
                        <strong>FECHA Y HORA</strong>
                        <span>{selectedHistoryEvent.fecha}</span>
                      </div>
                      <div className="info-box" style={{ background: 'rgba(255,255,255,0.02)' }}>
                        <strong>EJECUTADO POR</strong>
                        <span>{selectedHistoryEvent.usuario_uid}</span>
                      </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '30px' }}>
                      {parsed.fields.map((f, i) => (
                        <div key={i} style={{ 
                          padding: '20px', 
                          background: 'rgba(15, 23, 42, 0.4)', 
                          border: '1px solid var(--glass-border)', 
                          borderRadius: '16px',
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '15px'
                        }}>
                          {f.icon && <i className={f.icon} style={{ marginTop: '4px', color: parsed.color, fontSize: '18px' }}></i>}
                          <div>
                            <div style={{ fontSize: '10px', color: 'var(--p-slate)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '5px' }}>{f.label}</div>
                            <div style={{ color: 'var(--p-navy)', fontSize: '14px', lineHeight: '1.5' }}>{f.value}</div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {selectedHistoryEvent.evidencia && (
                      <div style={{ marginTop: '20px' }}>
                        <div style={{ fontSize: '10px', color: 'var(--p-slate)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '15px' }}>Evidencia Fotográfica de Respaldo:</div>
                        <div style={{ 
                          borderRadius: '20px', 
                          overflow: 'hidden', 
                          border: '1px solid var(--glass-border)',
                          background: 'rgba(0,0,0,0.2)',
                          padding: '10px',
                          textAlign: 'center'
                        }}>
                          <img 
                            src={selectedHistoryEvent.evidencia} 
                            alt="Evidencia" 
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '400px', 
                              borderRadius: '15px', 
                              cursor: 'zoom-in',
                              objectFit: 'contain'
                            }} 
                            onClick={() => window.open(selectedHistoryEvent.evidencia, '_blank')} 
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      {isScannerOpen && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal" style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h3>Escanear Código de Equipo</h3>
              <button className="close-modal-btn" onClick={() => setIsScannerOpen(false)}>&times;</button>
            </div>
            <div id="reader" style={{ width: '100%', minHeight: '300px' }}></div>
            <p style={{ textAlign: 'center', marginTop: '20px', color: 'var(--p-slate)', fontSize: '13px' }}>
              Apunta la cámara al código QR impreso en el equipo.
            </p>
          </div>
        </div>
      )}

      {selectedEntrega && (
        <div className="modal-overlay" onClick={() => setSelectedEntrega(null)}>
          <div className="modal-content premium-modal animate-slide-up" style={{ maxWidth: '560px', padding: '30px', borderRadius: '20px' }} onClick={e => e.stopPropagation()}>
            {/* Header con ícono */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', paddingBottom: '20px', borderBottom: '1px solid var(--glass-border)', marginBottom: '25px' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg, var(--p-emerald), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '18px', flexShrink: 0 }}>
                <i className="fa-solid fa-hand-holding-box"></i>
              </div>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '800', color: 'var(--p-navy)', margin: 0 }}>Gestión de Entrega</h3>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--p-slate)' }}>Entrega física al solicitante autorizado</p>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {/* Solicitante */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '18px', background: 'var(--sidebar-accent)', border: '1px solid var(--glass-border)', borderRadius: '14px' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px', fontWeight: '700', flexShrink: 0 }}>{(selectedEntrega.usuario_nombre || '?').charAt(0)}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '11px', color: 'var(--p-blue)', fontWeight: '700', marginBottom: '3px' }}>Solicitante Autorizado</div>
                  <div style={{ fontSize: '16px', fontWeight: '800', color: 'var(--p-navy)' }}>{selectedEntrega.usuario_nombre}</div>
                  <div style={{ fontSize: '12px', color: 'var(--p-slate)', marginTop: '2px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <i className="fa-solid fa-building" style={{ fontSize: '10px' }}></i> {selectedEntrega.departamento} 
                    <span style={{ opacity: 0.3 }}>·</span> 
                    <span style={{ fontFamily: 'var(--font-mono)' }}>{selectedEntrega.usuario_rut}</span>
                  </div>
                </div>
              </div>

              {/* Equipo */}
              <div style={{ padding: '18px', borderRadius: '14px', background: 'var(--bg-subtle)', border: '1px solid var(--glass-border)' }}>
                <div style={{ fontSize: '11px', color: 'var(--p-slate)', fontWeight: '700', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <i className="fa-solid fa-laptop" style={{ color: 'var(--p-blue)', fontSize: '10px' }}></i> Equipo a Entregar
                </div>
                <div style={{ fontSize: '16px', color: 'var(--p-blue)', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <i className="fa-solid fa-laptop-code"></i>
                  {selectedEntrega.equipo_solicitado}
                </div>
              </div>

              {/* Motivo */}
              <div style={{ padding: '18px', borderRadius: '14px', background: 'var(--bg-subtle)', border: '1px dashed var(--glass-border)' }}>
                <div style={{ fontSize: '11px', color: 'var(--p-slate)', fontWeight: '700', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <i className="fa-solid fa-comment-dots" style={{ color: 'var(--p-amber)', fontSize: '10px' }}></i> Motivo de Solicitud
                </div>
                <div style={{ fontSize: '14px', fontStyle: 'italic', color: 'var(--p-navy)', lineHeight: '1.6', opacity: 0.85 }}>
                  &ldquo;{selectedEntrega.motivo}&rdquo;
                </div>
              </div>
            </div>

            <div className="modal-footer-actions" style={{ marginTop: '30px' }}>
              <button className="btn-secondary" style={{ height: '48px', borderRadius: '12px' }} onClick={() => setSelectedEntrega(null)}>Cancelar</button>
              {selectedEntrega.estado === 'Pendiente de Firma' ? (
                <button className="btn-primary" style={{ flex: 1, height: '48px', borderRadius: '12px', justifyContent: 'center' }} onClick={handleContinuarFirmaPendiente}>
                  <i className="fa-solid fa-file-signature" style={{ marginRight: '8px' }}></i> Firmar Acta Pendiente
                </button>
              ) : (
                <button className="btn-primary" style={{ flex: 1, height: '48px', borderRadius: '12px', justifyContent: 'center' }} onClick={handleAbrirSmartAssign}>
                  <i className="fa-solid fa-boxes-packing" style={{ marginRight: '8px' }}></i> Procesar Asignación
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {showSmartAssignModal && assignSolicitud && (
        <div className="modal-overlay" onClick={() => setShowSmartAssignModal(false)}>
          <div className="modal-content premium-modal animate-slide-up" style={{ maxWidth: '620px', padding: '30px', borderRadius: '20px' }} onClick={e => e.stopPropagation()}>
            {/* Header con ícono */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', paddingBottom: '20px', borderBottom: '1px solid var(--glass-border)', marginBottom: '25px' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '18px', flexShrink: 0 }}>
                <i className="fa-solid fa-wand-magic-sparkles"></i>
              </div>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '800', color: 'var(--p-navy)', margin: 0 }}>Asignación Inteligente</h3>
                <p style={{ margin: 0, fontSize: '12px', color: 'var(--p-slate)' }}>Selecciona y asigna un equipo al solicitante</p>
              </div>
            </div>
            
            {/* Tarjeta destinatario */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '18px', background: 'var(--sidebar-accent)', border: '1px solid var(--glass-border)', borderRadius: '14px', marginBottom: '24px' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px', fontWeight: '700', flexShrink: 0 }}>{(assignSolicitud.usuario_nombre || '?').charAt(0)}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '11px', color: 'var(--p-blue)', fontWeight: '700', marginBottom: '3px' }}>Entregando a</div>
                <div style={{ fontSize: '16px', fontWeight: '800', color: 'var(--p-navy)' }}>{assignSolicitud.usuario_nombre}</div>
                <div style={{ fontSize: '12px', color: 'var(--p-slate)', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <i className="fa-solid fa-laptop" style={{ fontSize: '10px' }}></i> {assignSolicitud.equipo_solicitado}
                </div>
              </div>
            </div>

            {/* Origen del equipo */}
            <div className="premium-field" style={{ marginBottom: '22px' }}>
              <label><i className="fa-solid fa-route" style={{ color: 'var(--p-indigo)' }}></i> Origen del Equipo</label>
              <div style={{ display: 'flex', gap: '12px' }}>
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', background: assignData.modo === 'inventario' ? 'var(--sidebar-accent)' : 'var(--bg-subtle)', border: '2px solid', borderColor: assignData.modo === 'inventario' ? 'var(--p-blue)' : 'var(--glass-border)', borderRadius: '12px', cursor: 'pointer', transition: 'all 0.3s' }}>
                  <input type="radio" name="assignMode" checked={assignData.modo === 'inventario'} onChange={() => setAssignData({ ...assignData, modo: 'inventario' })} style={{ accentColor: 'var(--p-blue)', width: '18px', height: '18px' }} />
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--p-navy)' }}>Desde Inventario</div>
                    <div style={{ fontSize: '10px', color: 'var(--p-slate)' }}>Equipos en bodega</div>
                  </div>
                </label>
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', background: assignData.modo === 'manual' ? 'var(--sidebar-accent)' : 'var(--bg-subtle)', border: '2px solid', borderColor: assignData.modo === 'manual' ? 'var(--p-blue)' : 'var(--glass-border)', borderRadius: '12px', cursor: 'pointer', transition: 'all 0.3s' }}>
                  <input type="radio" name="assignMode" checked={assignData.modo === 'manual'} onChange={() => setAssignData({ ...assignData, modo: 'manual' })} style={{ accentColor: 'var(--p-blue)', width: '18px', height: '18px' }} />
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--p-navy)' }}>Ingreso Manual</div>
                    <div style={{ fontSize: '10px', color: 'var(--p-slate)' }}>Descripción libre</div>
                  </div>
                </label>
              </div>
            </div>

            {assignData.modo === 'inventario' ? (
              <div className="premium-field animate-fade-in" style={{ marginBottom: '25px' }}>
                <label><i className="fa-solid fa-magnifying-glass" style={{ color: 'var(--p-blue)' }}></i> Equipo Disponible <span style={{ fontWeight: '400', color: 'var(--p-slate)', fontSize: '11px' }}>(Smart Match)</span></label>
                {(() => {
                  const sugeridos = equipos.filter(eq => {
                    if (!['Sin uso', 'Operativo', 'Disponible'].includes(eq.estado)) return false;
                    const match = assignSolicitud?.equipo_solicitado?.match(/\[.*?\s-\s(.*?)\]/);
                    if (match && match[1]) {
                      return eq.categoria === match[1];
                    }
                    return true;
                  });

                  if (sugeridos.length === 0) {
                    return (
                      <div style={{ textAlign: 'center', padding: '35px', color: 'var(--p-slate)', background: 'var(--bg-subtle)', borderRadius: '14px', border: '1px dashed var(--glass-border)' }}>
                        <i className="fa-solid fa-box-open" style={{ fontSize: '24px', display: 'block', marginBottom: '10px', opacity: 0.4 }}></i>
                        <div style={{ fontSize: '13px' }}>No se encontraron equipos disponibles en bodega para esta categoría.</div>
                      </div>
                    );
                  }

                  return (
                    <div 
                      className="scroll-area custom-scrollbar" 
                      style={{ maxHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', padding: '4px', paddingRight: '10px' }}
                    >
                      {sugeridos.map(eq => {
                        const isSelected = assignData.equipoSeleccionado === `${eq.modelo} (${eq.codigo})`;
                        const statusColor = eq.estado === 'Sin uso' ? 'var(--p-blue)' : 'var(--p-emerald)';
                        
                        return (
                          <div 
                            key={eq.id}
                            onClick={() => setAssignData({ ...assignData, equipoSeleccionado: isSelected ? '' : `${eq.modelo} (${eq.codigo})` })}
                            style={{
                              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                              padding: '14px 18px',
                              background: isSelected ? 'var(--sidebar-accent)' : 'var(--bg-subtle)',
                              border: '2px solid', borderColor: isSelected ? 'var(--p-emerald)' : 'var(--glass-border)',
                              borderRadius: '12px', cursor: 'pointer', transition: 'all 0.2s ease',
                              boxShadow: isSelected ? '0 4px 15px -5px rgba(16, 185, 129, 0.3)' : 'none'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                              <div style={{ 
                                width: '40px', height: '40px', borderRadius: '10px', 
                                background: isSelected ? 'var(--p-emerald)' : 'var(--sidebar-accent)',
                                color: isSelected ? '#fff' : 'var(--p-blue)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '16px', transition: 'all 0.2s ease'
                              }}>
                                <i className={eq.clase === 'Periferico' ? 'fa-solid fa-keyboard' : 'fa-solid fa-laptop'}></i>
                              </div>
                              <div>
                                <div style={{ fontSize: '14px', fontWeight: '700', color: 'var(--p-navy)', marginBottom: '2px' }}>{eq.modelo}</div>
                                <div style={{ fontSize: '11px', color: 'var(--p-slate)', fontFamily: 'var(--font-mono)' }}>{eq.codigo}</div>
                              </div>
                            </div>
                            
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <span style={{ fontSize: '10px', fontWeight: '700', padding: '4px 10px', borderRadius: '8px', background: `${statusColor}15`, color: statusColor }}>{eq.estado}</span>
                              <div style={{ 
                                width: '22px', height: '22px', borderRadius: '50%', 
                                border: '2px solid', borderColor: isSelected ? 'var(--p-emerald)' : 'var(--glass-border)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                background: isSelected ? 'var(--p-emerald)' : 'transparent',
                                transition: 'all 0.2s ease'
                              }}>
                                {isSelected && <i className="fa-solid fa-check" style={{ color: '#fff', fontSize: '10px' }}></i>}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
            ) : (
              <div className="premium-field animate-fade-in" style={{ marginBottom: '25px' }}>
                <label><i className="fa-solid fa-keyboard" style={{ color: 'var(--p-amber)' }}></i> Descripción / Código del Equipo</label>
                <input 
                  type="text" 
                  style={{ width: '100%', height: '50px' }}
                  placeholder="Ej: Mouse Inalámbrico Logi / SN-12345"
                  value={assignData.textoManual}
                  onChange={(e) => setAssignData({ ...assignData, textoManual: e.target.value })}
                />
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
              <button className="btn-primary" style={{ flex: 1, height: '48px', borderRadius: '12px', justifyContent: 'center' }} onClick={() => handleConfirmarSmartAssign(true)}>
                <i className="fa-solid fa-signature" style={{ marginRight: '8px' }}></i> Firmar Presencial
              </button>
              <button className="btn-secondary" style={{ flex: 1, height: '48px', borderRadius: '12px', justifyContent: 'center', borderColor: 'var(--p-amber)', color: 'var(--p-amber)' }} onClick={() => handleConfirmarSmartAssign(false)}>
                <i className="fa-solid fa-envelope" style={{ marginRight: '8px' }}></i> Dejar Pendiente
              </button>
            </div>
            <button className="btn-secondary" style={{ width: '100%', height: '42px', borderRadius: '12px', justifyContent: 'center', opacity: 0.7 }} onClick={() => setShowSmartAssignModal(false)}>
              <i className="fa-solid fa-xmark" style={{ marginRight: '6px' }}></i> Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
